export default {
    address: {
        city: "Ciudad",
        city_locality: "Ciudad \/ Localidad",
        country: "País",
        line1: "Dirección Línea 1",
        line2: "Línea de dirección 2",
        postal_code: "Código Postal",
        state: "Estado",
        state_region: "Estado \/ Región"
    },
    alerts: {
        account_2fa: "Proteja su cuenta con autenticación de dos factores.",
        account_2fa_success: "La autenticación de dos factores está habilitada.",
        activate_instruction: "Al activar la recopilación automática de reseñas, se intentará solicitar una reseña a {count}. Revisa tus plantillas antes de activarla.",
        activate_intro: "Solicita continuamente reseñas en función de tu estrategia.",
        agency_mcp_server: "Conecta a Claude o a cualquier cliente de MCP al servidor MCP de tu agencia. Los asistentes autorizados podrán gestionar los proyectos, clientes y equipo de tu agencia en tu nombre.",
        agency_sso: "Conecte un proveedor de identidad OpenID Connect para el inicio de sesión del cliente.",
        ai_assistant: "Se requiere el nombre y la descripción de su empresa para utilizar IA para sugerencias y respuestas de reseñas.",
        ai_review_pages: "Permite sugerencias de reseña con IA en las páginas que selecciones.",
        api_key_roll: "¿Seguro que quieres cambiar tu clave API ? Esto afectará a todas las aplicaciones que la utilicen.",
        ask_confirm: "¿Está seguro de que desea solicitar reseñas de {count}? Esto programará solicitudes para todos los clientes a los que aún no se les haya solicitado.",
        automate_highlights: "Resalta automáticamente frases en las nuevas reseñas positivas.",
        automate_replies: "Publica automáticamente respuestas de IA en las nuevas reseñas de Google y Facebook. Requiere una [integración de Google o Facebook](\/settings\/integrations?tab=review).",
        cname_delete: "¿Está seguro de que desea eliminar el CNAME: {cname_name}?",
        cname_not_configured: "Este registro aún no se ha configurado. Espere, por favor.",
        cname_warning: "Los mensajes que ya se han enviado a sus clientes tendrán enlaces rotos.",
        connection_disabled: "La conexión está desactivada. Vuelva a conectarse.",
        customer_archive: "¿Está seguro de que desea archivar el cliente: {customer_name}? Se cancelarán todos los mensajes no enviados.",
        customer_cancel: "¿Está seguro de que desea cancelar todos los mensajes no enviados para el cliente: {customer_name}?",
        customer_ingest: "Incluya esta dirección de correo electrónico en el campo CCO al enviar correos electrónicos a sus clientes para que su nombre y dirección de correo electrónico se importen automáticamente.",
        customer_resubscribe: "¿Está seguro de que desea volver a suscribir al cliente: {customer_name}?",
        customer_unarchive: "¿Está seguro de que desea desarchivar el cliente: {customer_name}?",
        customer_unsubscribe: "¿Está seguro de que desea cancelar la suscripción del cliente: {customer_name}?",
        customer_unsubscribe_all: "¿Está seguro de que desea cancelar la suscripción de {count} para dejar de recibir mensajes de este proyecto?",
        delete: "¿Está seguro de que desea eliminar {model}: {name}?",
        delete_count: "¿Estás seguro de que deseas eliminar {count}?",
        domain_agency: "Agregue su propio dominio de envío para darle a su agencia una etiqueta completamente blanca.",
        domain_delete: "¿Está seguro de que desea eliminar el dominio {name}? Continuaremos enviando correos electrónicos desde nuestro propio nombre de dominio.",
        domain_dmarc: "Agrega un registro DMARC a tu dominio para reducir la posibilidad de que tus correos electrónicos vayan a la carpeta de spam.",
        domain_project: "Agregue un dominio de envío para que podamos enviar correos electrónicos a sus clientes desde su propio nombre de dominio.",
        export_confirm: "¿Está seguro de que desea exportar todos sus {model}?",
        export_count: "¿Está seguro de que desea exportar {count}?",
        export_link: "Se enviará un enlace de descarga a {email} poco después de que realice la solicitud.",
        highlights_save_disabled: "Opcionalmente, puede eliminar los aspectos destacados de todas las reseñas que actualmente los tengan.",
        highlights_save_enabled: "Para resaltar todas las reseñas positivas, marque la casilla a continuación. Si solo desea cambiar el color de resaltado, deje la casilla sin marcar.",
        integration_disconnect: "¿Está seguro de que desea desconectarse de {integration_name}?",
        integration_sync: "¿Está seguro de que desea sincronizar su cuenta {integration_name}? Importaremos sus datos continuamente.",
        intro: "Empieza importando a tus clientes. Luego envía las solicitudes de reseña tú mismo, o déjanos enviarlas por ti.",
        intro_help: "Si necesitas ayuda, {demo}.",
        logout: "¿Estás seguro que deseas cerrar la sesión?",
        mcp_server: "Conecta a Claude o a cualquier cliente de MCP a este proyecto. El servidor de MCP permite que los asistentes de IA lean y gestionen reseñas, clientes y mensajes en tu nombre.",
        member_confirm: "¿Estás seguro de que deseas eliminarte? Perderás el acceso a este proyecto.",
        member_confirm_all: "¿Estás seguro de que deseas eliminarte? Perderás el acceso a todos tus proyectos.",
        member_other_confirm: "¿Está seguro de que desea eliminar {noun}: {name}? Perderán el acceso a este proyecto.",
        member_other_confirm_all: "¿Está seguro de que desea eliminar {noun} {name}? Perderán el acceso a todos sus proyectos.",
        message_cancel: "¿Está seguro de que desea cancelar este mensaje?",
        message_cancel_all: "¿Está seguro de que desea cancelar {count}? Esta acción solo se puede realizar en mensajes no enviados.",
        message_delete: "¿Estás seguro que deseas eliminar este mensaje?",
        oauth_client_revoke: "¿Está seguro de que desea revocar el acceso para {client}? Todas las sesiones activas se desconectarán inmediatamente.",
        project_summary: "No es posible generar un resumen en este momento.",
        project_suspend: "¿Está seguro de que desea suspender el proyecto: {project_name}?",
        project_unsuspend: "¿Está seguro de que desea anular la suspensión del proyecto: {project_name}?",
        review_delete: "¿Estás seguro de que deseas eliminar esta reseña? Esta acción no se puede deshacer.",
        review_page_confirm: "¿Está seguro de que desea guardar los cambios?",
        review_page_confirmation: "Muestre un mensaje de confirmación en la página de éxito según la calificación seleccionada.",
        review_page_default: "¿Está seguro de que desea que la página de Reseña {name} sea su página predeterminada? Esta página se utilizará si no se asigna ninguna otra página a una solicitud de Reseña.",
        review_page_delete: "¿Está seguro de que desea eliminar la página de Reseña: {name}? Todos los clientes que actualmente son redirigidos a esta página serán redirigidos a su página predeterminada.",
        review_page_delete_all: "¿Está seguro de que desea eliminar {count}? Su página de Reseña predeterminada no se eliminará.",
        review_page_fields: "Utilice campos para capturar información del cliente cuando deje una reseña. Agregue más campos a su formulario y muéstrelos de manera condicional cuando los clientes seleccionen una calificación.",
        review_page_instructions: "Mostrar instrucciones directamente encima del formulario después de seleccionar una calificación.",
        review_page_location_picker: "Permita que los clientes seleccionen cualquier ubicación en su proyecto para la Reseña. Esta opción estará preseleccionada si la página de Reseña está destinada a mostrarse para una ubicación específica.",
        review_page_locations: "Seleccione las ubicaciones que deben utilizar esta página de Reseña. Una ubicación solo puede asignarse a una página de Reseña. Si no se le asigna una, se utilizará la página de Reseña predeterminada.",
        review_page_redirects: "Omitir el formulario después de seleccionar una calificación y redirigir a otro sitio. También puede dividir el tráfico a varios sitios web agregando más de una redirección para cada calificación.",
        review_page_review_suggestions: "Ayude a los clientes a escribir reseñas con sugerencias listas para usar que pueden editar antes de enviarlas.",
        share_template_delete: "¿Está seguro de que desea eliminar la plantilla compartida \"{name}\"? Esta acción es irreversible.",
        smtp_remove: "¿Está seguro de que desea eliminar la configuración SMTP de su proyecto? Su dominio de envío volverá a la configuración estándar.",
        smtp_setup: "Envíe correos electrónicos desde su propio servidor de correo. Introduzca sus credenciales SMTP . Si su servidor utiliza restricciones de IP, incluya en la lista blanca las siguientes IP utilizadas por nuestro sistema: {ips}.",
        space_delete: "¿Seguro que quieres eliminar el espacio de trabajo: {name}? Se eliminarán todos los proyectos que contiene.",
        tag_rule: "Añade un término positivo y su contraparte negativa. Si corresponde, utilizaremos IA para etiquetar automáticamente la reseña con uno u otro.",
        user_delete: "¿Está seguro de que desea eliminar la cuenta de usuario: {email}?",
        user_verify: "Para verificar su dirección de correo electrónico y activar su cuenta, haga clic en el enlace del correo electrónico enviado a: {email}.",
        widget_delete: "¿Está seguro de que desea eliminar el widget: {name}? El widget ya no se mostrará en ningún sitio web.",
        widget_restore: "¿Está seguro de que desea restaurar la configuración del widget: {name}? Solo el diseño volverá a los valores predeterminados.",
        widgets_1: "Añade este script al body de tu sitio web.",
        widgets_2: "El Muro de reseñas muestra todas tus reseñas en una cuadrícula. Añade este script donde quieras que se muestre el widget.",
        widgets_3: "El widget Reseña destacada muestra una única reseña en grande. Añade este script donde quieras que se muestre el widget."
    },
    billing_statuses: {
        active: "Su suscripción está activa.",
        canceled: "Tu suscripción está cancelada. Actualiza tu suscripción para continuar.",
        ending: "Tu suscripción finaliza el {date}.",
        trial: "Su prueba gratuita finaliza el {date}.",
        trial_expired: "Tu prueba gratuita ha finalizado. Actualiza para continuar.",
        trial_expiring: "Tu prueba gratuita terminará pronto. Actualiza tu suscripción para continuar."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "Correo electrónico",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Mensajero",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Agregue un dominio de envío para editar su dirección de correo electrónico:",
        agency_robots: "Permita que los motores de búsqueda indexen su portal de clientes.",
        analytics_average_review: "Calificación promedio de estrellas en este período.",
        analytics_customers: "Clientes añadidos y clientes a los que se les pidió una reseña por primera vez.",
        analytics_limits: "Solicitudes de reseña de hoy y de este mes.",
        analytics_location_leaderboard: "Número de reseñas, calificación promedio y porcentaje de 5 estrellas por ubicación.",
        analytics_needs_attention: "Reseñas de 1 y 2 estrellas de los últimos 3 meses sin respuesta.",
        analytics_outreach: "Mensajes enviados, clicados y fallidos a lo largo del tiempo.",
        analytics_reply_coverage: "Porcentaje de reseñas que tienen una respuesta.",
        analytics_review_velocity: "Promedio de reseñas recibidas por semana.",
        analytics_review_volume: "Cuántas reseñas recibiste en este período.",
        analytics_sentiment: "Reseñas escritas clasificadas como positivas, neutrales o negativas.",
        analytics_source_mix: "Número de reseñas y calificación promedio por fuente.",
        analytics_star_mix: "Número de reseñas a lo largo del tiempo por calificación de estrellas.",
        analytics_tags: "Etiquetas más usadas en este período, con recuento y promedio.",
        ai_business_description: "Una descripción detallada de su negocio para ayudar a generar sugerencias de reseñas y respuestas.",
        ai_business_name: "El nombre de su negocio.",
        ai_highlights: "Resalta las mejores frases de tus reseñas positivas.",
        ai_highlights_instructions: "Indica a la IA qué frases priorizar en los resaltados.",
        ai_replies: "Redacta y, si quieres, automatiza las respuestas a tus reseñas.",
        ai_reply_contact: "Se incluye en las respuestas a reseñas negativas.",
        ai_reply_instructions: "Indica a la IA cómo deben sonar las respuestas y qué incluir.",
        ai_review_instructions: "Indica a la IA qué mencionar o evitar en las sugerencias de reseña.",
        ai_review_suggestions: "Ayuda a los clientes a escribir reseñas con sugerencias listas para usar.",
        ai_tags: "Etiqueta automáticamente las reseñas que coincidan con tus instrucciones.",
        ask_location: "La ubicación que se asignará a la Reseña.",
        ask_review_page: "La página para capturar la reseña.",
        assign_tags: "Asignar etiquetas a la reseña.",
        csv_max_rows: "Hasta {count} filas",
        dashboard_configure_settings: "Configure los ajustes de su proyecto.",
        dashboard_import_customers: "Importa tus clientes.",
        dashboard_preview_email_templates: "Obtenga una vista previa de sus plantillas de correo electrónico.",
        dashboard_preview_kiosk_page: "Obtenga una vista previa de su página de quiosco.",
        dashboard_preview_review_page: "Obtenga una vista previa de su página de Reseña.",
        dashboard_preview_showcase_page: "Obtenga una vista previa de su página de presentación.",
        detect_from_website: "Déjelo en blanco para detectarlo desde el sitio web.",
        logo_height: "La altura del logotipo en correos electrónicos y páginas.",
        meta_description: "Anular la descripción de la página.",
        meta_title: "Anular el título de la página.",
        mfa_password: "Introduzca la contraseña de su cuenta.",
        mfa_qr_code: "Escanee el código QR con su aplicación de autenticación.",
        mfa_security_code: "Introduzca el código de su aplicación de autenticación.",
        mcp_server_url: "Pega esta URL en Claude, ChatGPT o cualquier cliente MCP.",
        other_website_url: "Requisitos:<br>Calificación: de 1 a 5 estrellas<br>Fecha: En los últimos 2 años<br>Solo páginas públicas",
        override_ambassador: "Muestra una insignia en los correos electrónicos, páginas y widgets de tus clientes.",
        project_name: "El nombre de su empresa, marca o sitio web.",
        project_robots: "Permite que los motores de búsqueda indexen tus páginas de reseñas y tu Showcase.",
        project_slug: "Se utiliza en correos electrónicos y enlaces orientados al cliente si no se configura un CNAME .",
        qr_fallback_redownload: "Descarga el código de nuevo después de añadir esto.",
        qr_fallback_url: "Se utiliza si el proyecto se suspende o se elimina.",
        review_page_copied_message: "Se muestra después de enviar una reseña positiva.",
        review_page_email_address: "Recibe reseñas en este correo electrónico.",
        review_page_link_reveal_position: "Dónde revelar los enlaces.",
        review_page_link_revealer_label: "La etiqueta para revelar los enlaces.",
        review_page_link_revealer_rating: "Revelar enlaces si el cliente selecciona esta calificación o una superior, de lo contrario mostrar un botón para revelarlos.",
        review_page_native_reviews: "Permitir reseñas en esta plataforma.",
        review_page_rating_selection: "Guarde la calificación antes de enviar una reseña.",
        review_page_success_button_link: "Si está en blanco, el enlace predeterminado es el sitio web de su proyecto; de lo contrario, el enlace es el dominio de la página.",
        review_page_warning: "Si impides que los clientes dejen reseñas públicas, es posible que se elimine tu ficha empresarial.",
        review_reply_status: "No podemos responder públicamente a esta reseña. Puedes contactar directamente con el autor de la reseña.",
        scrape_facebook_url: "Requisitos:<br>Hasta 100 reseñas recientes<br>Solo páginas públicas",
        scrape_linkedin_url: "Requisitos:<br>Solo recomendaciones<br>Solo páginas públicas",
        scrape_trustpilot_url: "Requisitos:<br>Calificación: de 1 a 5 estrellas<br>Solo páginas públicas",
        separate_with_commas: "Separar múltiples con comas.",
        setup_basics: "Define cuándo y cómo pides reseñas a tus clientes.",
        setup_business: "Díganos cómo le conocen sus clientes.",
        setup_google: "Envía a los clientes a tu perfil de Google , responde a las reseñas e importa las existentes. Puedes omitir este paso y hacerlo más tarde.",
        setup_location_limit: "Tu prueba gratuita incluye 1 ubicación. Actualiza tu plan cuando quieras para sincronizar más ubicaciones.",
        showcase_locations: "Limite la exhibición a ubicaciones específicas.",
        showcase_review_length: "Las Reseñas deben tener al menos esta cantidad de caracteres.",
        showcase_since: "Mostrar reseñas creadas en o antes de esta fecha.",
        showcase_sources: "Limite la exhibición a fuentes específicas.",
        showcase_tags: "Limite la presentación a reseñas con etiquetas específicas.",
        signature_html: "Copia y pega la firma en tu aplicación de correo electrónico.",
        signed_up: "La fecha de inicio del cliente.",
        twilio_webhook: "Establezca como URL de devolución de llamada para su servicio de mensajería.",
        widget_embed: "Opcional. El ID de un elemento existente donde debe aparecer el Widget.",
        widget_wordpress: "Instala el plugin y luego pega este Shortcode donde debería aparecer el Widget."
    },
    labels: {
        accept_all: "Aceptar todo",
        access_code: "Código de acceso",
        access_codes: "Códigos de acceso",
        account: "Cuenta",
        account_sid: "SID de la cuenta",
        action: "Acción",
        actions: "Acciones",
        activate: "Activar",
        active: "Activo",
        add: "Agregar",
        add_agency_project: "Agregar un proyecto de agencia",
        add_confirmation_message: "Añade un mensaje de confirmación.",
        add_css_rules: "Añade tus propias reglas CSS.",
        add_custom_field: "Agregar campo personalizado",
        add_customer: "Agregar un cliente",
        add_customers_with: "Agregar clientes con {model}",
        add_external_link: "Agregar un Enlace externo",
        add_external_links: "Agregar Enlaces externos",
        add_introduction: "Añade una introducción.",
        add_js_tags: "Añade tus propias etiquetas JavaScript.",
        add_legal_information: "Añadir información legal.",
        add_location: "Agregar una ubicación",
        add_project: "Agregar un proyecto",
        add_review: "Añadir una Reseña",
        add_source: "Agregar una fuente",
        add_tag: "Agregar una Etiqueta",
        added: "Agregado",
        address: "Dirección",
        advanced_review_pages: "Páginas de Reseña avanzada",
        affiliates: "Afiliados",
        age_of_reviews: "Antigüedad de las reseñas",
        agencies: "Agencias",
        agency: "Agencia",
        agency_name: "Nombre de la agencia",
        agency_project: "Proyecto de Agencia",
        agency_projects: "Proyectos de la Agencia",
        ai: "AI",
        ai_answers: "Respuestas de IA",
        ai_assistant: "Asistente de IA",
        ai_auto_tagging: "Etiquetado con IA",
        ai_highlights_instructions: "Ejemplo: Prioriza frases sobre el servicio o nuestra marca.",
        ai_reply_instructions: "Ejemplo: Mantén las respuestas cortas. Invita a contactarnos si la reseña es negativa.",
        ai_review_instructions: "Ejemplo: Menciona al personal y la visita. No menciones precios.",
        ai_review_suggestions: "Sugerencias de reseña de IA",
        ai_reviews_and_replies: "Sugerencias y respuestas de Reseña de IA",
        ai_tagging_instructions: "Ejemplo: Aplicar a reseñas que mencionen tiempos de espera, servicio lento o demoras.",
        ai_tags: "Etiquetas de IA",
        ai_tools: "Herramientas de IA",
        all: "Todo",
        allowed_domains: "Dominios permitidos",
        amount: "Cantidad",
        analytics: "Analítica",
        and: "y",
        anonymous_reviews: "Reseñas anónimas",
        answer: "Respuesta",
        any: "Cualquier",
        api: "API",
        api_key: "Clave API",
        appearance: "Apariencia",
        apply: "Aplicar",
        approved: "Aprobado",
        archive: "Archivo",
        archive_customer: "Archivar cliente",
        archived: "Archivado",
        at_least: "al menos",
        at_least_days: "Al menos {num} días",
        at_least_hours: "Al menos {num} horas",
        at_least_months: "Al menos {num} meses",
        at_most: "a lo sumo",
        at_most_days: "Como máximo {num} días",
        at_most_hours: "Como máximo {num} horas",
        at_most_months: "Como máximo {num} meses",
        auth_token: "Token de autenticación",
        authorize: "Autorizar",
        auto_detect: "Auto",
        auto_tags: "Etiquetas de IA",
        automate: "Automatizar",
        automate_highlights: "Automatizar resaltados",
        automate_replies: "Automatizar respuestas",
        automatic_review_collection: "Recopilación automática de Reseña",
        automatically_apply_tags: "Aplicar automáticamente la etiqueta a las reseñas existentes",
        automating: "Automatización",
        avatar: "Avatar",
        avatars: "Avatares",
        average_charge: "Cargo promedio",
        average_review: "Reseña promedio",
        background_color: "Color de fondo",
        background_image: "Imagen de fondo",
        back: "Atrás",
        bcc: "BCC",
        bcc_email_address: "Dirección de correo electrónico BCC",
        best_to_worst: "De lo mejor a lo peor",
        billing: "Facturación",
        blog: "The Reviews Guy",
        body: "Contenido",
        body_font_size: "Tamaño de fuente del Contenido",
        bold: "Negrita",
        book_a_demo: "Reservar una demo",
        bottom: "Abajo",
        bottom_left: "Abajo a la izquierda",
        bottom_right: "Abajo a la derecha",
        build_on: "Construir sobre {model}",
        business: "Business",
        business_description: "Descripción del negocio",
        business_email: "Dirección de correo electrónico de soporte",
        business_name: "Nombre de la empresa",
        business_phone: "Número de teléfono de soporte",
        business_website: "Sitio web de negocios",
        button: "Botón",
        button_label: "Etiqueta para Botón",
        button_link: "Enlace para Botón",
        button_position: "Posición del Botón",
        button_size: "Tamaño del Botón",
        buy_me_a_coffee: "Invítame a un café",
        by: "por",
        by_signing_up: "Al crear una cuenta, usted acepta nuestros",
        call_to_action: "Llamado a la acción",
        cancel: "Cancelar",
        cancel_1_message: "Cancelar 1 mensaje",
        cancel_message: "Cancelar mensaje",
        cancel_messages: "Cancelar mensajes {count}",
        cancel_subscription: "Cancelar suscripción",
        cancel_unsent_messages: "Cancelar mensajes no enviados",
        canceled: "Cancelado",
        center: "Centro",
        change: "Cambiar",
        change_key: "Cambiar su clave API",
        change_plan: "Plan de cambio",
        changelog: "Registro de cambios",
        channel: "Canal",
        channels: "Canales",
        characters: "Caracteres",
        charges_avg: "La carga media debe ser al menos",
        charges_count: "El número de cargas debe ser al menos",
        charges_sum: "Los cargos totales deben ser al menos",
        chat_with_us: "Chatea con nosotros",
        chatgpt: "ChatGPT",
        checkbox: "Casilla de verificación",
        claude: "Claude",
        clear: "Claro",
        clear_highlights_from_reviews: "Eliminar los elementos destacados de todas las reseñas",
        clicked: "Hice clic",
        client: "Cliente",
        client_id: "ID de Cliente",
        clients: "Clientela",
        close: "Cerca",
        cloudflare_warning: "Si usa Cloudflare, su proxy debe estar desactivado.",
        cname: "CNAME",
        cname_setup_incomplete: "Configuración incompleta: se eliminará en {date}",
        cname_ssl_pending: "Esperando certificado SSL",
        cname_status_for: "Estado CNAME para",
        code_editor: "Editor de código",
        collapse: "Contraer",
        collect_reviews_anywhere: "Recopila reseñas en cualquier lugar",
        color: "Color",
        colors: "Colores",
        commission_rate: "Tasa de comisión",
        commission_status_approved: "Aprobado",
        commission_status_paid: "Pagado",
        commission_status_pending: "Pendiente",
        commission_status_reversed: "Invertido",
        community: "Comunidad",
        company: "Compañía",
        complained: "Se quejó",
        confirm_new_password: "Confirmar nueva contraseña",
        confirmation_message: "Mensaje de confirmación",
        configure: "Configurar",
        connect: "Conectar",
        connect_bank: "Conectar cuenta bancaria",
        connect_google: "Conectar Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Conectado",
        consent_preferences: "Preferencias de consentimiento",
        contact_customer: "Contactar al cliente",
        contact_form: "Formulario de contacto",
        contact_support: "Por favor póngase en contacto con el soporte técnico.",
        contact_us: "Contáctenos",
        container_element: "Elemento contenedor",
        context: "Contexto",
        continue: "Continuar",
        continue_with_google: "Continuar con Google",
        cookie_category_analytics: "Analítica",
        cookie_category_essential: "Básico",
        cookie_category_functional: "Funcional",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Banner de consentimiento de cookies",
        cookie_consent_scope_all: "Mostrar a todos",
        cookie_consent_scope_eea: "Mostrar solo a visitantes del EEE y del Reino Unido",
        cookie_consent_scope_none: "No mostrar",
        cookie_policy: "Política de cookies",
        cookie_preference: "Preferencias de cookies",
        copied: "Copiado",
        copied_message: "Mensaje copiado",
        copy: "Copiar",
        copy_embed_code: "Copiar código para incrustar",
        copy_signature: "Firma de correo",
        copy_source_code: "Copiar código fuente",
        copy_to_all_ratings: "Copiar a todas las calificaciones",
        copy_uuid: "Copiar UUID",
        create: "Crear",
        create_account: "Crear una cuenta",
        create_agency: "Crear una agencia",
        create_cname: "Cree un registro CNAME y apúntelo a",
        create_external_link: "Crear un Enlace externo",
        create_field: "Crear un campo",
        create_link: "Crear un Enlace",
        create_location: "Crear una ubicación",
        create_project: "Crear un proyecto",
        create_qr_code: "Crear código QR",
        create_review: "Crear una Reseña",
        create_review_page: "Crear una Página de Reseña",
        create_signature: "Crear una firma de correo",
        create_source: "Crear una fuente",
        create_space: "Crea un espacio de trabajo",
        create_tag: "Crear una Etiqueta",
        create_tag_rule: "Crear una regla de Etiqueta",
        create_webhook: "Crear un webhook",
        create_widget: "Crear un widget",
        created_with_ai_based_on_recent_reviews: "Creado con IA, basado en reseñas recientes",
        crms: "CRMs",
        csv: "CSV",
        currency: "Divisa",
        current_plan: "Plan actual",
        current_year: "Año corriente",
        custom_field: "Campo personalizado",
        custom_instructions: "Instrucciones personalizadas",
        custom_url: "URL personalizada",
        customer: "Cliente",
        customer_name_convention: "Convención de nombres de clientes",
        customer_reviews: "Reseñas de clientes",
        customers: "Clientes",
        customize: "Personalizar",
        customize_review_page: "Personalizar Página de Reseña",
        daily: "A diario",
        daily_email_requests: "Solicitudes diarias por correo electrónico",
        daily_limit: "Límite diario",
        daily_requests: "Solicitudes diarias",
        daily_sms_requests: "Solicitudes diarias de SMS",
        dark: "Oscuro",
        dashboard: "Panel de control",
        date: "Fecha",
        date_added: "Fecha añadida",
        date_canceled: "Fecha de cancelación",
        date_clicked: "Fecha en la que se hizo clic",
        date_complained: "Fecha de la queja",
        date_delivered: "Fecha de entrega",
        date_failed: "Fecha fallida",
        date_messaged: "Fecha del mensaje",
        date_opened: "Fecha de apertura",
        date_replied: "Fecha de respuesta",
        date_requested: "Fecha solicitada",
        date_reviewed: "Fecha de la reseña",
        date_scheduled: "Fecha programada",
        date_sent: "Fecha de envío",
        date_signed_up: "Fecha de inscripción",
        date_updated: "Fecha de actualización",
        dates: "Fechas",
        day: "Día",
        days: "Días",
        days_after_last_request: "días después de la última solicitud",
        days_later: "días después",
        deactivate: "Desactivar",
        default: "Por defecto",
        default_language: "Idioma predeterminado",
        default_review_page: "Página de Reseña predeterminada",
        default_review_visibility: "Visibilidad de Reseña predeterminada",
        default_tone: "Tono predeterminado",
        delay: "Demora",
        delete: "Borrar",
        delete_1_customer: "Eliminar 1 cliente",
        delete_1_review: "Eliminar 1 Reseña",
        delete_1_review_page: "Eliminar 1 Página de reseña",
        delete_1_widget: "Eliminar 1 widget",
        delete_agency: "Eliminar Agencia",
        delete_custom_field: "Eliminar campo personalizado",
        delete_customer: "Eliminar cliente",
        delete_customers: "Eliminar clientes",
        delete_external_link: "Eliminar Enlace externo",
        delete_field: "Eliminar campo",
        delete_link: "Eliminar Enlace",
        delete_location: "Eliminar ubicación",
        delete_message: "Eliminar mensaje",
        delete_n_customers: "Eliminar clientes {count}",
        delete_n_review_pages: "Eliminar Páginas de reseña {count}",
        delete_n_reviews: "Eliminar Reseñas {count}",
        delete_n_widgets: "Eliminar widgets {count}",
        delete_project: "Eliminar proyecto",
        delete_qr_code: "Eliminar código QR",
        delete_reply: "Eliminar respuesta",
        delete_review: "Eliminar Reseña",
        delete_review_page: "Eliminar Página de Reseña",
        delete_review_pages: "Eliminar Páginas de Reseña",
        delete_reviews: "Eliminar Reseñas",
        delete_signature: "Eliminar firma de correo",
        delete_source: "Eliminar fuente",
        delete_space: "Eliminar espacio de trabajo",
        delete_tag: "Eliminar Etiqueta",
        delete_tag_rule: "Eliminar regla de Etiqueta",
        delete_template: "Eliminar plantilla",
        delete_user: "Eliminar usuario",
        delete_webhook: "Eliminar webhook",
        delete_widget: "Eliminar widget",
        delete_widgets: "Eliminar widgets",
        deleted: "Eliminado",
        delivered: "Entregado",
        description: "Descripción",
        deselect_all: "Deseleccionar todo",
        disable: "Desactivar",
        disable_automatic_review_collection: "Desactivar la recopilación automática de Reseña",
        disable_field: "Deshabilitar campo",
        disable_when_links_are_visible: "Desactivar cuando los enlaces son visibles",
        disabled: "Desactivado",
        disconnect: "Desconectar",
        disconnect_integration: "Desconectar la integración",
        discord_community: "Comunidad de Discord",
        display_name: "Nombre para mostrar",
        dmarc: "DMARC",
        dmarc_status_for: "Estado DMARC para",
        do_not_hide_from_public: "No ocultar del público",
        do_not_send: "No enviar",
        docs: "Documentos",
        documentation: "Documentación",
        domain: "Dominio",
        domain_name: "Nombre de dominio",
        dont_have_an_account: "¿No tienes una cuenta?",
        dont_send_thanks: "No envíes agradecimientos",
        done: "Hecho",
        download: "Descargar",
        download_plugin: "Descargar plugin",
        download_records: "Descargar registros",
        download_template: "Descargar plantilla",
        dpa: "DPA",
        dsar: "DSAR",
        dropdown: "Lista desplegable",
        duplicate: "Duplicado",
        duplicate_project: "Proyecto duplicado",
        duplicate_review_page: "Página de Reseña duplicada",
        duplicate_reviews: "Reseñas duplicadas",
        duplicate_widget: "Widget duplicado",
        edit: "Editar",
        edit_1_customer: "Editar 1 Cliente",
        edit_1_review: "Editar 1 Reseña",
        edit_client: "Editar Cliente",
        edit_custom_field: "Editar campo personalizado",
        edit_customer: "Editar cliente",
        edit_customers: "Editar clientes",
        edit_field: "Editar campo",
        edit_link: "Editar Enlace",
        edit_location: "Editar ubicación",
        edit_member: "Editar miembro",
        edit_n_customers: "Editar {count} Clientes",
        edit_n_reviews: "Editar {count} Reseñas",
        edit_notes: "Editar notas",
        edit_qr_code: "Editar código QR",
        edit_reviews: "Editar Reseñas",
        edit_signature: "Editar firma de correo",
        edit_source: "Editar fuente",
        edit_strategy: "Editar estrategia",
        edit_tag: "Editar Etiqueta",
        edit_tag_rule: "Editar regla de Etiqueta",
        edit_tags: "Editar etiquetas",
        edit_team_member: "Miembro del equipo de edición",
        edit_visibility: "Editar visibilidad",
        edit_webhook: "Editar webhook",
        editable_ratings: "Calificaciones editables",
        earned: "Ganado",
        eligible: "Elegible",
        email: "Correo electrónico",
        email_address: "Dirección de correo electrónico",
        email_validation_invalid: "La validación del correo electrónico falló",
        email_validation_passed: "Validación de correo electrónico aprobada",
        email_validation_unknown: "No se pudo verificar el correo electrónico",
        emails: "Correos electrónicos",
        embed_code: "Código para insertar",
        enable: "Permitir",
        enable_automatic_review_collection: "Habilitar la recopilación automática de Reseña",
        enable_for_all_reviews: "Habilitar para todas las reseñas",
        enable_for_positive_reviews: "Habilitar para reseñas positivas",
        enable_on_review_pages: "Habilitar en páginas de Reseña",
        enabled: "Activado",
        end: "Fin",
        ends: "Finaliza",
        exclude: "Excluir",
        exclude_email: "Excluir correo electrónico",
        exclude_sms: "Excluir SMS",
        excluded_channels: "Canales excluidos",
        expand: "Expandir",
        expired: "Venció",
        export: "Exportar",
        export_1_customer: "Exportar 1 cliente",
        export_1_review: "Exportar 1 Reseña",
        export_all: "Exportar todo",
        export_all_customers: "Exportar todos los clientes",
        export_all_reviews: "Exportar todas las Reseñas",
        export_customers: "Clientes de exportación",
        export_n_customers: "Exportar clientes {count}",
        export_n_reviews: "Exportar Reseñas {count}",
        export_reviews: "Exportar Reseñas",
        external_link: "Enlace externo",
        external_links: "Enlaces externos",
        extra_locations: "Ubicaciones adicionales",
        faces: "Caras",
        failed: "Fallido",
        fallback_url: "URL de reserva",
        feedback: "Comentario",
        feedback_form: "Formulario de comentarios",
        field: "Campo",
        fields: "Campos",
        filter: "Filtrar",
        first: "Primero",
        first_charged: "Primer cobro",
        first_name: "Nombre de pila",
        first_name_last_initial: "Nombre, inicial del apellido",
        five_star_share: "5 estrellas %",
        flag_as_duplicate: "Marcar como duplicado",
        font: "Fuente",
        font_family: "Familia de fuentes",
        font_size: "Tamaño de fuente",
        footer: "Pie de página",
        for: "Para",
        forgot_password: "Has olvidado tu contraseña",
        form: "Formulario",
        free: "Gratis",
        free_requests_included: "Solicitudes gratuitas incluidas",
        from: "de",
        full_name: "Nombre completo",
        generate: "Generar",
        generate_meta: "Generar metadatos",
        generate_qr_code: "Generar código QR",
        generate_reply: "Generar respuesta",
        generate_review: "Generar Reseña",
        generating: "Generando",
        get_started: "Empezar",
        get_started_checklist: "Lista de verificación para comenzar",
        get_the_lifetime_deal: "Obtenga la oferta de por vida",
        getting_started: "Empezando",
        google_fonts: "Fuentes de Google",
        grouped_by_request: "Agrupados por solicitud",
        has_links: "Tiene enlaces",
        has_notes: "Tiene notas",
        has_redirects: "Tiene redirecciones",
        have_an_account: "¿Tienes una cuenta?",
        header: "Encabezamiento",
        hidden: "Oculto",
        hidden_from_search_engines: "Oculto para los motores de búsqueda",
        hidden_reviews: "Reseñas ocultas",
        hide: "Esconder",
        hide_all_reviews: "Ocultar todas las reseñas",
        hide_avatar: "Ocultar avatar",
        hide_date: "Ocultar fecha",
        hide_drop_shadow: "Ocultar sombra paralela",
        hide_field_label: "Ocultar etiqueta de campo",
        hide_from_public: "Ocultar del público",
        hide_name: "Ocultar nombre",
        hide_pagination: "Ocultar paginación",
        highlight_color: "Resaltar color",
        hipaa: "HIPAA",
        host: "Host",
        hours: "Horas",
        icon: "Icono",
        icon_size: "Tamaño del icono",
        icons: "Iconos",
        id: "ID",
        image: "Imagen",
        import: "Importar",
        import_address1: "La línea de dirección del cliente 1.",
        import_address2: "La línea de dirección del cliente 2.",
        import_city: "La ciudad o localidad del cliente.",
        import_company: "El nombre de la empresa del cliente.",
        import_created_at: "La fecha de la Reseña.",
        import_customers: "Importar clientes",
        import_email: "La dirección de correo electrónico del cliente.",
        import_first_name: "El nombre del cliente.",
        import_from_boost_space: "Importar desde Boost.space",
        import_from_hubspot: "Importar desde HubSpot",
        import_from_make_com: "Importar desde Make.com",
        import_from_pabbly: "Importar desde Pabbly",
        import_from_stripe: "Importar desde Stripe",
        import_from_zapier: "Importar desde Zapier",
        import_last_name: "El apellido del cliente.",
        import_list: "Lista separada por comas de",
        import_notes: "Notas para uso interno únicamente.",
        import_phone: "El número de teléfono del cliente.",
        import_postal_code: "El código postal del cliente.",
        import_recent_reviews: "Importar Reseñas recientes",
        import_review: "El texto de la reseña.",
        import_reviews: "Reseñas de importación",
        import_score: "La calificación del 1 al 5.",
        import_signed_up_at: "La fecha de inicio del cliente.",
        import_slug: "El slug o UUID de un",
        import_state: "El estado o región del cliente.",
        import_yourself: "Importarte a ti mismo",
        incentive: "Incentivo",
        include: "Incluir",
        include_sample_reviews: "Incluir ejemplos de reseñas",
        incoming_webhook_url: "URL de webhook entrante",
        inherit: "Heredar",
        initializing: "Inicializando",
        initials: "Iniciales",
        install_in: "Instalar en",
        insert_variable: "Insertar variable",
        instructions: "Instrucciones",
        integration: "Integración",
        integrations: "Integraciones",
        interval: "Intervalo",
        introduction: "Introducción",
        invite: "Invitar",
        invite_client: "Invitar al Cliente",
        invite_failed: "Invitación fallida",
        invite_member: "Invitar miembro",
        invite_sent_to: "Invitación enviada a",
        invite_team_member: "Invitar a un miembro del equipo",
        invited: "Invitado",
        issuer_url: "URL del emisor",
        italic: "Itálico",
        joined: "Unido",
        key: "Llave",
        keywords: "Palabras clave",
        keywords_in_replies: "Palabras clave en las respuestas",
        keywords_in_reviews: "Palabras clave en las Reseñas",
        kiosk_page: "Página del quiosco",
        label: "Etiqueta",
        label_font_size: "Tamaño de fuente de la etiqueta",
        labels: "Etiquetas",
        language: "Idioma",
        languages: "Idiomas",
        large: "Grande",
        last_12_months: "Últimos 12 meses",
        last_2_years: "Últimos 2 años",
        last_3_months: "Últimos 3 meses",
        last_4_weeks: "Últimas 4 semanas",
        last_6_months: "Últimos 6 meses",
        last_charged: "Último cargo",
        last_name: "Apellido",
        layout: "Disposición",
        leave: "Dejar",
        leave_project: "Abandonar proyecto",
        leave_space: "Abandonar espacio de trabajo",
        left: "Izquierda",
        let_clients_sign_in_with_sso: "Permitir que los clientes inicien sesión con SSO",
        less: "menos",
        lifecycle_stage: "Etapa del ciclo de vida",
        lifetime_deal: "Oferta de por vida",
        lifetime_deal_terms: "Términos de la oferta de por vida",
        light: "Luz",
        limit: "Límite",
        limits: "Límites",
        link: "Enlace",
        link_color: "Color del enlace",
        link_reveal_position: "Posición de revelación de Enlace",
        link_revealer_button: "Botón Revelador de Enlace",
        link_revealer_label: "Etiqueta reveladora de enlaces",
        link_revealer_rating: "Puntuación del revelador de enlaces",
        links: "Enlaces",
        links_per_review_page: "Enlaces por Página de Reseña",
        list: "Lista",
        list_unsubscribe_headers: "Encabezados de List-Unsubscribe",
        load_more: "Cargar más",
        loading: "Cargando",
        location: "Ubicación",
        location_address: "Ubicación Dirección",
        location_name: "Nombre de la ubicación",
        location_picker: "Selector de ubicación",
        locations: "Ubicaciones",
        locations_limit: "Límite de ubicaciones",
        log_in: "Acceso",
        log_out: "Finalizar la sesión",
        logo: "Logo",
        logo_height: "Altura del logotipo",
        long: "Largo",
        lowest_rating: "Calificación más baja",
        ltd: "LTD",
        make_default: "Establecer como predeterminado",
        manage: "Administrar",
        manage_limits: "Gestionar límites",
        manage_overrides: "Administrar anulaciones",
        manage_payout_account: "Administrar cuenta de pagos",
        manage_subscription: "Administrar suscripción",
        manual_entry: "Entrada manual",
        max: "Máximo",
        max_size: "Tamaño máximo",
        maximum_characters: "Máximo de Caracteres",
        maximum_customers: "Máximo de clientes",
        maximum_locations: "Ubicaciones máximas",
        maximum_members: "Máximo de miembros",
        maximum_review_length: "Longitud máxima de la Reseña",
        maximum_tags: "Máximo de Etiquetas",
        maximum_widgets: "Máximo de widgets",
        mcp: "Servidor MCP",
        mcp_server: "Servidor MCP",
        mcp_server_url: "URL del Servidor MCP",
        medium: "Medio",
        member: "Miembro",
        members: "Miembros",
        menu: "Menú",
        message: "Mensaje",
        message_link_expiration: "Caducidad del Enlace del mensaje",
        messaged: "Enviado un mensaje",
        messages: "Mensajes",
        messages_clicked: "Mensajes en los que se hizo clic",
        messages_sent: "Mensajes enviados",
        messaging_service_sid: "SID del servicio de mensajería",
        min: "Mínimo",
        min_size: "Tamaño mínimo",
        minimal_delay: "Retraso mínimo",
        minimum_characters: "Caracteres mínimos",
        minutes: "Minutos",
        month: "mes",
        month_to_date: "Mes hasta la fecha",
        monthly: "Mensual",
        monthly_email_requests: "Solicitudes mensuales por correo electrónico",
        monthly_limit: "Límite mensual",
        monthly_pricing_only: "Solo precios mensuales",
        monthly_request_limit: "Límite de solicitud mensual",
        monthly_requests: "Solicitudes mensuales",
        monthly_sms_requests: "Solicitudes de SMS mensuales",
        months: "Meses",
        months_free: "{count} Meses gratis",
        more: "más",
        more_clients: "más clientes",
        more_customers: "más clientes",
        more_options: "Más opciones",
        more_patients: "más pacientes",
        more_reviews: "más reseñas",
        more_reviews_needed: "Se necesitan más reseñas para resumir",
        more_users: "más usuarios",
        more_visitors: "más visitantes",
        most_negative: "Más negativos",
        most_positive: "Más positivos",
        move: "Mover",
        moved: "Movido",
        name: "Nombre",
        native_reviews: "Reseñas nativas",
        negative: "Negativo",
        negative_term: "Término negativo",
        new: "Nuevo",
        new_password: "Nueva contraseña",
        newest: "Más recientes",
        neutral: "Neutral",
        no: "No",
        no_available_options: "No hay opciones disponibles",
        no_credit_card_required: "No se requiere tarjeta de crédito",
        no_data_available: "No hay datos disponibles",
        no_reminders: "No envíes recordatorios",
        no_retries: "Sin reintentos",
        no_review: "Sin reseña",
        none: "Ninguno",
        not_connected: "No conectado",
        not_reviewed: "No Reseñado",
        notes: "Notas",
        notifications: "Notificaciones",
        now: "Ahora",
        n_1_ai_tag: "1 etiqueta de IA",
        n_1_review_page: "1 página de reseña",
        n_ai_tags: "{count} etiquetas de IA",
        n_review_pages: "{count} páginas de reseña",
        number_of_charges: "Número de cargos",
        number_of_reminders: "Número de recordatorios",
        number_of_retries: "Número de reintentos",
        number_of_review_suggestions: "Número de sugerencias de Reseña",
        of: "de",
        off: "Apagado",
        on: "En",
        on_for_positive_reviews: "Activado para reseñas positivas",
        on_channel: "en el canal {channel}.",
        opened: "Abierto",
        options: "Opciones",
        or_log_in_with_email: "o inicia sesión con tu dirección de correo electrónico",
        or_sign_up_with_email: "o utiliza tu dirección de correo electrónico",
        other_website: "Otro sitio web",
        our_reviews: "Nuestras Reseñas",
        output: "Producción",
        page_footer: "Pie de página",
        paid: "Pagado",
        paragraph: "Párrafo",
        password: "Contraseña",
        past_month: "El mes pasado",
        past_months: "Últimos {inc} meses",
        past_week: "La semana pasada",
        past_year: "El año pasado",
        past_years: "Últimos {inc} años",
        paused: "En pausa",
        payment_method: "Método de pago",
        payout_status_completed: "Terminado",
        payout_status_pending: "Pendiente",
        pending: "Pendiente",
        pending_deployment: "Implementación pendiente",
        pending_validation: "Pendiente de validación",
        per_day: "por día",
        per_month: "por mes",
        period: "Período",
        permissions: "Permisos",
        phone: "Teléfono",
        phone_number: "Número de teléfono",
        pixels: "píxeles",
        placeholder: "Marcador de posición",
        placement: "Colocación",
        plan: "Plan",
        plan_bullet1: "Eliminar nuestra marca en correos electrónicos, páginas y widgets",
        plan_bullet2: "Utilice su dominio para páginas orientadas al cliente y envío de correos electrónicos",
        plan_bullet3: "Haz tuyo el producto con el etiquetado blanco para agencias",
        please_rate_our_service: "Por favor, valora nuestro servicio.",
        png: "PNG",
        policies: "Políticas",
        positive: "Positivo",
        popular: "Popular",
        port: "Puerto",
        position: "Posición",
        positive_only: "Solo Reseñas positivas",
        positive_term: "Término positivo",
        powered_by: "Desarrollado por",
        preview: "Vista previa",
        preview_kiosk_page: "Ver página de quiosco",
        preview_review_page: "Ver página de reseña",
        price: "Precio",
        pricing: "Precios",
        primary_color: "Color primario",
        priority: "Prioridad",
        privacy_policy: "política de privacidad",
        proceed_to_dashboard: "Ir al panel de control",
        product: "Producto",
        profile: "Perfil",
        project: "Proyecto",
        project_name: "Nombre del proyecto",
        setup_ask_delay: "¿Cuánto tiempo hay que esperar antes de pedir una reseña?",
        setup_reminders: "¿Cuántos recordatorios enviar?",
        project_paused: "Este proyecto está en pausa.",
        project_suspended: "Este proyecto está suspendido.",
        project_website: "Sitio web del proyecto",
        projects: "Proyectos",
        projects_limit: "Límite de proyectos",
        publish: "Publicar",
        publish_changes: "Publicar los cambios en todas las demás páginas de Reseña",
        published: "Publicado",
        purchase: "Compra",
        qr_code: "Código QR",
        qr_code_name_placeholder: "Mesa 1, Recepción",
        qr_codes: "Códigos QR",
        quarter_to_date: "Trimestre hasta la fecha",
        quantity: "Cantidad",
        query: "Consulta",
        quick_import: "Importación rápida",
        rating: "Puntuación",
        rating_order: "Orden de calificación",
        rating_out_of: "calificación de",
        rating_save_all: "Guardar la calificación antes de cada Reseña",
        rating_save_customer: "Guardar la calificación antes de la Reseña del cliente",
        rating_save_never: "Nunca guardes la calificación antes de la reseña",
        rating_selection: "Selección de calificación",
        rating_selector: "Selector de calificación",
        ratings: "Calificaciones",
        read: "Leer",
        reapply_highlights_eligible: "Regenera los aspectos más destacados con IA para todas las reseñas positivas.",
        reconnect: "Reconectar",
        redeem: "Canjear",
        redirect_uri: "URI de redirección",
        redirects: "Redirecciones",
        refer_and_earn: "Recomienda y gana",
        referral_billing_status_active: "Suscrito",
        referral_billing_status_canceled: "Cancelado",
        referral_billing_status_trial: "Prueba",
        referral_billing_status_trial_expired: "El período de prueba ha expirado.",
        referral_billing_status_trial_expiring: "El período de prueba expira",
        referral_program: "Términos del programa de referidos",
        referral_program_terms: "Términos del programa de referidos",
        referrals: "Referencias",
        refresh: "Refrescar",
        regenerate: "Regenerar",
        reject_all: "Rechazar todo",
        related_reviews: "Reseñas similares",
        related_similarity: "Semejanza",
        remaining: "Restante",
        reminder: "Recordatorio",
        reminders: "Recordatorios",
        remove: "Eliminar",
        remove_client: "Eliminar Cliente",
        remove_cname: "Eliminar CNAME",
        remove_domain: "Eliminar dominio",
        remove_from_project: "Eliminar del proyecto",
        remove_member: "Eliminar miembro",
        remove_smtp_configuration: "Eliminar la configuración SMTP",
        remove_team_member: "Eliminar miembro del equipo",
        rename: "Rebautizar",
        rename_template: "Cambiar nombre de la plantilla",
        renews: "Renueva",
        replied: "Respondió",
        reply: "Responder",
        reply_coverage: "Cobertura de respuestas",
        replies: "Respuestas públicas",
        replies_disabled: "Respuestas públicas desactivadas",
        reply_to: "Dirección de respuesta",
        replying_on: "Respondiendo a",
        request: "Solicitud",
        request_1_review: "Solicitar 1 reseña",
        request_date: "Fecha de solicitud",
        request_n_reviews: "Solicitar {count} reseñas",
        request_review: "Solicitar una Reseña",
        request_reviews: "Solicitar Reseñas",
        requested: "Solicitado",
        requested_review: "Reseña solicitada",
        requests: "Solicitudes",
        requests_left_this_month: "solicitudes que quedan este mes",
        requests_remaining: "Solicitudes restantes",
        require_field: "Campo requerido",
        require_sso: "Requiere inicio de sesión único (SSO)",
        required: "Requerido",
        reschedule_message: "Reprogramar mensaje",
        resend_invite: "Reenviar invitación",
        reset_password: "Restablecer contraseña",
        restore: "Restaurar",
        restore_to_defaults: "Restaurar a valores predeterminados",
        restore_widget: "Restaurar widget",
        resubscribe: "Volver a suscribirse",
        resubscribe_customer: "Volver a suscribir al cliente",
        resync: "Resincronizar",
        resync_account: "Volver a sincronizar la cuenta",
        resync_now: "Volver a sincronizar ahora",
        retries: "Reintentos",
        reveal_above_form: "Revelar por encima del formulario",
        reveal_after_submission: "Revelar después de la sumisión",
        reveal_below_form: "Revelar debajo del formulario",
        review: "Reseña",
        review_length: "Duración de la Reseña",
        review_link: "Enlace de Reseña",
        review_missed: "Reseña perdida",
        review_not_requested: "Reseña no solicitada",
        review_origin: "Esta reseña se originó a partir de una plantilla",
        review_page: "Página de reseña",
        review_pages: "Páginas de reseña",
        review_requested: "Reseña solicitada",
        review_spotlight: "Reseña destacada",
        review_suggestion: "Sugerencia de Reseña",
        review_suggestions: "Sugerencias de Reseña",
        review_summary: "Resumen de reseñas",
        review_text: "Texto de Reseña",
        review_velocity: "Reseñas por semana",
        review_volume: "Volumen de reseñas",
        review_wall: "Muro de reseñas",
        reviewed: "Reseñado",
        reviews: "Reseñas",
        reviews_ask: "Preguntar",
        reviews_query_failed: "Algo salió mal. Por favor, inténtalo de nuevo.",
        reviews_query_placeholder: "Busca reseñas o haz una pregunta...",
        reviews_with_highlights: "Reseñas con aspectos destacados",
        reviews_with_replies: "Reseñas con respuestas",
        reviews_without_replies: "Reseñas sin respuestas",
        revoke: "Revocar",
        revoke_client: "Revocar la aplicación",
        roadmap: "Hoja de ruta",
        role: "Rol",
        sans_serif: "Sin serifa",
        save: "Guardar",
        save_preferences: "Guardar preferencias",
        save_template: "Guardar plantilla",
        save_template_as_new: "Guardar nueva plantilla",
        saved: "Guardado",
        schedule: "Cronograma",
        schedule_review_request: "Programar solicitud de reseña",
        scheduled: "Programado",
        score: "Puntaje",
        search: "Buscar",
        second: "Segundo",
        secret_key: "Clave secreta",
        sections: "Secciones",
        security_code: "Código de seguridad",
        select: "Seleccionar",
        select_account: "Seleccione una cuenta",
        select_all: "Seleccionar todo",
        select_an_option: "Seleccione una opción",
        select_bulk_action: "Seleccionar acción masiva",
        select_csv_file: "Seleccionar archivo CSV",
        select_date: "Seleccionar fecha",
        select_field: "Seleccione un campo",
        select_icon: "Seleccione un icono",
        select_location: "Seleccione una ubicación",
        select_plan: "Seleccione un plan",
        select_review: "Seleccione una Reseña",
        select_source: "Seleccione una fuente",
        select_tag: "Seleccione una Etiqueta",
        selected: "Seleccionado",
        send: "Enviar",
        send_1_reminder: "Enviar 1 recordatorio",
        send_2_reminders: "Enviar 2 recordatorios",
        send_3_reminders: "Enviar 3 recordatorios",
        send_anytime: "Enviar en cualquier momento",
        send_between: "Enviar entre",
        send_message: "Enviar mensaje",
        send_retries: "Enviar reintentos {count}",
        send_retry: "Enviar {count} Reintentar",
        send_test: "Enviar una prueba",
        send_thanks: "Enviar agradecimiento",
        sender_email_address: "Dirección de correo electrónico del remitente",
        sender_id: "ID del remitente",
        sender_name: "Nombre del remitente",
        sending_domain: "Envío de dominio",
        sentiment: "Sentimiento",
        sent: "Enviado",
        sent_replies: "Respuestas enviadas",
        serif: "Serif",
        set_up: "Configurar",
        settings: "Ajustes",
        share: "Compartir",
        share_link: "Compartir Enlace",
        short: "Corto",
        shortcode: "Shortcode",
        show: "Mostrar",
        show_1_suggestion: "Mostrar 1 sugerencia",
        show_100_results: "Mostrar 100 resultados",
        show_2_suggestions: "Mostrar 2 sugerencias",
        show_25_results: "Mostrar 25 resultados",
        show_3_suggestions: "Mostrar 3 sugerencias",
        show_4_suggestions: "Mostrar 4 sugerencias",
        show_5_suggestions: "Mostrar 5 sugerencias",
        show_50_results: "Mostrar 50 resultados",
        show_all_reviews: "Mostrar todas las reseñas",
        show_arrows: "Mostrar flechas",
        show_avatar: "Mostrar avatar",
        show_cookie_consent_banner: "Mostrar el banner de consentimiento de cookies",
        show_date: "Mostrar fecha",
        show_dots: "Mostrar puntos",
        show_drop_shadow: "Mostrar sombra paralela",
        show_field: "Mostrar campo en las siguientes calificaciones",
        show_full: "Mostrar estrellas completas",
        show_photo: "Mostrar solo foto",
        show_positive_reviews: "Mostrar solo reseñas positivas",
        show_to_public: "Mostrar al público",
        showcase: "Showcase",
        showcase_page: "Página de presentación",
        sign_up: "Inscribirse",
        sign_up_for_free: "Regístrate gratis",
        sign_up_with_email: "Regístrate con correo electrónico",
        sign_in_with_sso: "Iniciar sesión con SSO",
        sign_up_with_google: "Regístrate con Google",
        signature: "Firma de correo",
        signatures: "Firmas de correo",
        signed_up: "Registrado",
        since: "Desde",
        size: "Tamaño",
        skip: "Saltar",
        skipped_required_fields: "Campos obligatorios omitidos: {fields}",
        slug: "Slug",
        small: "Pequeño",
        sms: "SMS",
        smtp_configuration: "Configuración SMTP",
        sort: "Clasificar",
        source: "Fuente",
        source_code: "Código fuente",
        sources: "Fuentes",
        space: "Espacio de trabajo",
        space_name: "Nombre del Espacio",
        spaces: "Espacios de trabajo",
        split: "Dividir",
        sso: "SSO",
        standard: "Estándar",
        star: "Estrella",
        star_color: "Color de estrella",
        stars: "Estrellas",
        start: "Comenzar",
        start_free_trial: "Comience una prueba gratuita",
        start_getting_more_reviews: "Empiece a recibir más Reseñas",
        start_over: "Reiniciar",
        status: "Estado",
        store_code: "Código de tienda",
        strategy: "Estrategia",
        sub_processors: "Subprocesadores",
        subject: "Sujeto",
        subscribe: "Suscribir",
        subscription: "Suscripción",
        success_page: "Pagina de éxito",
        suggestion: "Sugerencia",
        suggestions: "Sugerencias",
        summary: "Resumen",
        support: "Soporte",
        suspend: "Suspender",
        suspend_project: "Suspender proyecto",
        suspended: "Suspendido",
        svg: "SVG",
        switch_to_smtp_setup: "Cambiar a la configuración SMTP",
        switch_to_standard_setup: "Cambiar a la configuración estándar",
        symbol: "Símbolo",
        sync: "Sincronizar",
        sync_account: "Sincronizar cuenta",
        sync_now: "Sincronizar ahora",
        sync_scheduled_time: "Sincronización programada {time}",
        sync_with_facebook: "Sincronizar con Facebook",
        sync_with_google: "Sincronizar con Google",
        synced_time: "Sincronizado {time}",
        system: "Sistema",
        system_fonts: "Fuentes del sistema",
        tag: "Etiqueta",
        tag_1_customer: "Etiqueta 1 Cliente",
        tag_1_review: "Etiquetar 1 reseña",
        tag_customers: "Etiquetar clientes",
        tag_existing_reviews: "Etiqueta Reseñas existentes",
        tag_n_customers: "Etiqueta {count} Clientes",
        tag_n_reviews: "Etiqueta {count} Reseñas",
        tag_reviews: "Etiquetar reseñas",
        tag_rule: "Regla de etiqueta",
        tag_with_ai: "Etiqueta con IA",
        tags: "Etiquetas",
        tags_for_customers: "Etiquetas para clientes",
        tags_for_reviews: "Etiquetas para Reseñas",
        team: "Equipo",
        team_member: "Miembro del equipo",
        team_members: "Miembros del equipo",
        template: "Plantilla",
        templates: "Plantillas",
        terms_of_service: "Condiciones de servicio",
        test_template: "Plantilla de prueba",
        tests: "Pruebas",
        text: "Texto",
        text_alignment: "Alineación de texto",
        text_color: "Color del texto",
        thank_you_messages: "Mensajes de agradecimiento",
        thanks: "Gracias",
        theme: "Tema",
        third: "Tercero",
        time_zone: "Huso horario",
        timeframe: "Periodo de tiempo",
        title: "Título",
        tone: "Tono",
        top: "Arriba",
        top_left: "Arriba a la izquierda",
        top_right: "Arriba a la derecha",
        total_charges: "Cargos totales",
        total_reviews: "Total de Reseñas",
        trend_mentions: "{count} menciones, {percent}%",
        trigger: "Desencadenar",
        trigger_charged: "Enviar solicitud después de un cargo",
        trigger_created: "Enviar solicitud después del registro",
        try_free: "Pruebalo gratis",
        try_it_free: "Pruébalo gratis",
        type: "Tipo",
        types: "Tipos",
        unarchive: "Desarchivar",
        unarchive_customer: "Desarchivar cliente",
        underline: "Subrayar",
        unflag_as_duplicate: "Desmarcar como duplicado",
        unknown: "Desconocido",
        unlimited: "ilimitado",
        unnamed: "Sin nombre",
        unpublish: "Anular publicación",
        unpublished: "Inédito",
        unreplied: "Sin respuesta",
        unsent_messages: "Mensajes no enviados",
        unsubscribe: "Darse de baja",
        unsubscribe_1_customer: "Cancelar suscripción de 1 cliente",
        unsubscribe_customer: "Darse de baja del cliente",
        unsubscribe_customers: "Darse de baja de clientes",
        unsubscribe_n_customers: "Cancelar suscripción de {count} clientes",
        unsubscribe_text: "Texto para cancelar la suscripción",
        unsubscribed: "Darse de baja",
        unsuspend: "Reactivar",
        unsuspend_project: "Reactivar proyecto",
        unverified: "No verificado",
        update: "Actualizar",
        update_password: "Actualizar contraseña",
        update_plan: "Plan de actualización",
        update_share_template: "Plantilla de actualización",
        updated: "Actualizado",
        updates: "Actualizaciones",
        upgrade: "Mejora",
        upgrade_for_more: "Actualice para obtener más",
        upgrade_to_use: "Actualice para utilizar esta función",
        upload: "Subir",
        upload_csv: "Subir CSV",
        upload_icon: "Subir un icono",
        url: "URL",
        use: "Usar",
        use_filters_for_aggregate: "Utilice filtros para agregar",
        user: "Usuario",
        user_id: "ID de usuario",
        user_info: "Información del usuario",
        username: "Nombre de usuario",
        utc: "UTC",
        validate: "Validar",
        validate_customer_email: "Validar el correo electrónico del cliente",
        validation: "Validación",
        validations: "Validaciones",
        value: "Valor",
        verify: "Verificar",
        verify_email_address: "Verificar dirección de correo electrónico",
        view: "Ver",
        view_all: "Ver todo",
        view_all_features: "Ver todas las funciones",
        view_available_fields: "Ver campos disponibles",
        view_documentation: "Ver documentación",
        view_email_templates: "Ver plantillas de correo electrónico",
        view_review_pages: "Ver Páginas de Reseña",
        view_reviews: "Ver Reseñas",
        vs_prior: "vs. período anterior",
        view_settings: "Ver configuración",
        view_setup_guide: "Ver la guía de configuración",
        view_showcase: "Ver escaparate",
        view_strategy: "Ver estrategia",
        visibility: "Visibilidad",
        visible: "Visible",
        visible_reviews: "Reseñas visibles",
        visible_to_search_engines: "Visible para los motores de búsqueda",
        wait_between_reminders: "Esperar entre recordatorios",
        wait_period: "Período de espera",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Sitio web",
        weekly: "Semanalmente",
        weeks: "Semanas",
        widget: "Widget",
        widgets: "Widgets",
        with_ai: "con IA",
        wordpress: "WordPress",
        worst_to_best: "De peor a mejor",
        would_redirect_to: "Redirigiría a {url}",
        write: "Escribir",
        written_reviews: "Reseñas escritas",
        year: "año",
        year_to_date: "Año hasta la fecha",
        yearly: "Anual",
        yes: "Sí",
        you: "Tú",
        your_referral_link: "Tu Enlace de referencia"
    },
    landing: {
        announcement: "Gestiona las reseñas en {claude} o {chatgpt}",
        counter: "Únase a más de 5.000 negocios locales de servicios",
        counter_agencies: "Usado por más de 500 agencias para gestión de reseñas",
        counter_ai: "Gestiona las reseñas en {claude} o {chatgpt}",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Obtén respuestas sin iniciar sesión en otro panel de control.",
            "Actúa en función de la reputación en las herramientas de chat que tu equipo ya utiliza.",
            "Guardar horas cada semana preguntando en lugar de cavando."
        ],
        ai_screen_1_subtitle: "Tu gestión de reputación debe adaptarse a tus necesidades. Pregúntale a Claude o a ChatGPT qué necesita respuesta, a quién preguntar a continuación o cómo te fue la semana, y obtén respuestas en tiempo real sin cambiar de herramienta.",
        ai_screen_1_title: "Pregúntale a Claude o ChatGPT.",
        ai_screen_2_badge: "Respuestas de IA",
        ai_screen_2_bullets: [
            "Responde más rápido sin sonar genérico",
            "Nunca dejes reseñas sin responder cuando estés ocupado.",
            "Proteja la voz de su marca en cada respuesta pública."
        ],
        ai_screen_2_subtitle: "Cada reseña sin respuesta es una oportunidad perdida para ganarse la confianza de los clientes. La IA redacta respuestas que suenan como tu personalidad, para que puedas gestionar las consultas en minutos y estar disponible para tus clientes sin tener que escribir.",
        ai_screen_2_title: "Responder sin complicaciones",
        ai_screen_3_badge: "Sugerencias de IA",
        ai_screen_3_bullets: [
            "Consiga que más clientes lleguen a la meta.",
            "Recopilar comentarios específicos y que puedan ser compartidos.",
            "Convierte las visitas positivas en reseñas dignas de presumir."
        ],
        ai_screen_3_subtitle: "La mayoría de la gente tiene la intención de dejar una reseña, pero nunca lo hace. Utiliza un lenguaje claro y personal para que sus comentarios sean más concisos y convincentes.",
        ai_screen_3_title: "Obtén más reseñas de 5 estrellas",
        ai_screen_4_badge: "Etiquetado de IA",
        ai_screen_4_bullets: [
            "Detecta patrones antes de que se conviertan en problemas",
            "Encuentra los temas que realmente influyen en las calificaciones.",
            "Evita leer cientos de reseñas manualmente."
        ],
        ai_screen_4_subtitle: "No debería ser necesario releer todas las reseñas para saber qué está pasando. La IA organiza los comentarios según los temas que te interesan, para que puedas solucionar los problemas más rápido y potenciar lo que les encanta a los clientes.",
        ai_screen_4_title: "Sepa lo que dicen los clientes.",
        ai_summary_1_desc: "Redacta respuestas Google y Facebook que se ajusten a tu tono, o configura respuestas automáticas programadas.",
        ai_summary_1_title: "Respuestas de IA",
        ai_summary_2_desc: "Ofrezca a sus clientes sugerencias de reseñas listas para usar cuando dejen sus comentarios en su página.",
        ai_summary_2_title: "Sugerencias de revisión de IA",
        ai_summary_3_desc: "Resalta las mejores frases en las reseñas positivas en todos los widgets, la galería y las imágenes compartidas.",
        ai_summary_3_title: "Aspectos destacados de la IA",
        ai_summary_4_desc: "Aplica etiquetas a partir de las reglas que definas para que temas como los tiempos de espera o la calidad del servicio se mantengan organizados.",
        ai_summary_4_title: "Etiquetado automático mediante IA",
        ai_summary_5_desc: "Obtenga resúmenes concisos de las reseñas recientes con recuentos, temas y preocupaciones que merecen atención.",
        ai_summary_5_title: "Resúmenes de Reseña",
        ai_summary_6_desc: "Detecta los elogios crecientes y las quejas incipientes sin tener que leer todas las reseñas manualmente.",
        ai_summary_6_title: "Tendencias positivas y negativas",
        ai_summary_7_desc: "Busca reseñas similares junto a cualquier comentario para que los patrones y las repeticiones sean fáciles de ver.",
        ai_summary_7_title: "reseñas relacionadas",
        ai_summary_8_desc: "Formula preguntas en lenguaje sencillo sobre tus reseñas y obtén respuestas con referencias que puedes consultar.",
        ai_summary_8_title: "Pregúntale a la IA",
        ai_summary_9_desc: "Conecta Claude, ChatGPT y otros clientes de MCP para gestionar la reputación en el chat.",
        ai_summary_9_title: "MCP para asistentes",
        ai_summary_10_desc: "Obtenga informes de reputación en tiempo real que incluyan volumen, calificaciones, ubicaciones, respuestas y alcance.",
        ai_summary_10_title: "Informes de reputación",
        ai_summary_11_desc: "Guía el tono, las palabras clave y las instrucciones personalizadas para que cada resultado de la IA suene como tu marca.",
        ai_summary_11_title: "IA con reconocimiento de marca",
        ai_summary_12_desc: "Mide cuán positivas o negativas son las reseñas escritas, más allá de las estrellas, para ordenar lo que necesita atención.",
        ai_summary_12_title: "Sentimiento",
        industries: {
            accountants: "Contadores",
            auto_repair: "Mecánicos",
            chiropractors: "Quiroprácticos",
            camps: "Campamentos",
            cleaning: "Limpiadores",
            contractors: "Contratistas",
            dentists: "Dentistas",
            doctors: "Médicos",
            electricians: "Electricistas",
            financial_advisors: "Asesores financieros",
            hvac: "Técnicos de climatización",
            insurance_brokers: "Corredores de seguros",
            landscapers: "Jardineros",
            law_firms: "Abogados",
            locksmiths: "Cerrajeros",
            mortgage_brokers: "Corredores hipotecarios",
            optometrists: "Optometristas",
            personal_trainers: "Entrenadores personales",
            pest_control: "Exterminadores",
            physical_therapists: "Fisioterapeutas",
            plumbers: "Fontaneros",
            real_estate: "Agentes inmobiliarios",
            restaurants: "Dueños de restaurantes",
            salons: "Estilistas",
            self_storage: "Operadores de almacenamiento",
            spas: "Esteticistas",
            preschools: "Preescolares",
            tour_guides: "Guías turísticos",
            veterinarians: "Veterinarios"
        },
        industries_title: "Gestión de reseñas para negocios locales de servicios",
        stat_1_article: "Informe de investigación del consumidor",
        stat_1_desc: "La gente quiere ver más de 100 reseñas antes de confiar en un negocio online.",
        stat_1_source: "Salsifí",
        stat_1_title: "Las Reseñas generan confianza.",
        stat_2_article: "Encuesta de Reseña de consumidores locales",
        stat_2_desc: "Los compradores que comparan negocios locales prefieren aquellos que responden a todas las reseñas.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Elige quién responde",
        stat_3_article: "Reseñas, reputación e ingresos",
        stat_3_desc: "Un pequeño aumento en la calificación puede suponer un incremento real en tus ingresos.",
        stat_3_source: "Escuela de Negocios de Harvard",
        stat_3_title: "Ingresos por estrella",
        stat_4_article: "Dependencia de los consumidores en los resultados de búsqueda de IA",
        stat_4_desc: "Cuando la gente le pregunta a la IA a quién elegir, tus reseñas ayudan a redactar la respuesta.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Confía en la búsqueda por IA",
        subtitle: "Solicita reseñas automáticamente. Obtén más valoraciones de 5 estrellas. Posiciona mejor que tu competencia.",
        agencies_screen_1_badge: "Portal",
        agencies_screen_1_bullets: [
            "Venda un portal de marca con cada contrato de servicios.",
            "Mantén a tus clientes dentro de tu ecosistema, no en un sistema de inicio de sesión de terceros.",
            "Parecer una empresa de software, pero sin construir una."
        ],
        agencies_screen_1_subtitle: "Dale a cada cliente un portal que parece un producto que construiste: tu logo, tus colores, tu dominio. Luego empaqueta la gestión de reseñas como un servicio recurrente al que inician sesión cada mes. No estás recomendando una herramienta. Estás entregando una.",
        agencies_screen_1_title: "Un portal que parece que lo construiste tú",
        agencies_screen_2_badge: "Control",
        agencies_screen_2_bullets: [
            "Adapta las características a los paquetes básico, de crecimiento y premium.",
            "Invita a las personas adecuadas y controla lo que ve cada cliente.",
            "Anular solicitudes, ubicaciones y límites por proyecto"
        ],
        agencies_screen_2_subtitle: "No todos los clientes deben tenerlo todo. Invita equipos a proyectos específicos, define roles y anula funciones y límites por cuenta para que tus paquetes coincidan con cómo facturas. Upsellea acceso a medida que crecen, sin builds a medida para cada paquete.",
        agencies_screen_2_title: "Controla el acceso por cliente",
        agencies_screen_3_badge: "AI",
        agencies_screen_3_bullets: [
            "Ofrezca respuestas de IA que guardar a los clientes horas cada semana.",
            "Conecta a Claude u otros asistentes a través del MCP de cada proyecto.",
            "Comercializar la IA como un complemento premium para los clientes."
        ],
        agencies_screen_3_subtitle: "No solo gestiones reseñas. Dale a los clientes IA que redacta respuestas, etiqueta feedback y trabaja con Claude u otros asistentes vía el servidor MCP del proyecto. Es una capacidad moderna que las agencias pueden empaquetar, upsellear y renovar, sin un equipo de contenido para cada cuenta.",
        agencies_screen_3_title: "IA por la que los clientes pagarán",
        agencies_screen_4_badge: "Escala",
        agencies_screen_4_bullets: [
            "Gestiona las reseñas de varias empresas desde una sola cuenta.",
            "Agregue ubicaciones a medida que las gane, con precios por volumen.",
            "Convierta cada nuevo cliente en un ingreso recurrente."
        ],
        agencies_screen_4_subtitle: "Un asiento de agencia. Docenas de negocios. Ejecuta recopilación de reseñas, respuestas e informes en cada ubicación de cliente desde un solo hub, y crece el margen al añadir cuentas. Así las agencias convierten la reputación en un flujo de ingresos escalable, no en un proyecto puntual.",
        agencies_screen_4_title: "Escala en todos tus clientes",
        agencies_summary_10_desc: "Pon en contacto a Claude u otros asistentes para gestionar proyectos, clientes y el equipo.",
        agencies_summary_10_title: "Agencia MCP",
        agencies_summary_11_desc: "Cada cliente recibe el kit completo de herramientas de revisión: recopilación de datos, inteligencia artificial, widgets y mucho más.",
        agencies_summary_11_title: "Todo en los negocios",
        agencies_summary_12_desc: "Obtén ayuda de un equipo que comprende los flujos de trabajo de las agencias y los despliegues para los clientes.",
        agencies_summary_12_title: "Soporte especializado",
        agencies_summary_1_desc: "Los Clientes gestionan su reputación en un portal que tiene el aspecto de un producto que usted ha desarrollado.",
        agencies_summary_1_title: "Portal de clientes de marca",
        agencies_summary_2_desc: "Aloja el portal en tu dominio para que cada inicio de sesión se mantenga asociado a tu marca.",
        agencies_summary_2_title: "dominio de agencia aduanera",
        agencies_summary_3_desc: "Permita que sus clientes inicien sesión con su proveedor de identidad con un solo clic.",
        agencies_summary_3_title: "Inicio de sesión único",
        agencies_summary_4_desc: "Invite a los clientes a proyectos específicos y controle lo que pueden ver.",
        agencies_summary_4_title: "Invitaciones y roles de los Cliente",
        agencies_summary_5_desc: "Limita las solicitudes, ubicaciones y características por proyecto para que coincidan con tus paquetes.",
        agencies_summary_5_title: "Anulaciones por proyecto",
        agencies_summary_6_desc: "Otorgue a su equipo interno acceso completo a todos los proyectos de los clientes.",
        agencies_summary_6_title: "puestos del equipo de la agencia",
        agencies_summary_7_desc: "Empiece con 5 ubicaciones y, a medida que crezca, añada más con precios por volumen.",
        agencies_summary_7_title: "Escala de múltiples ubicaciones",
        agencies_summary_8_desc: "Las notificaciones del sistema se envían desde el dominio de su agencia y por proyecto cuando los clientes no han añadido las suyas propias.",
        agencies_summary_8_title: "Envío de marca blanca",
        agencies_summary_9_desc: "Automatice proyectos, clientes y equipos con la API de la agencia.",
        agencies_summary_9_title: "API de la agencia",
        demo_footer: "Elija un horario que le convenga. Le guiaremos por todo y responderemos sus preguntas.",
        desc_contact: "¿Tiene una pregunta o necesita ayuda con algo? Envíe un mensaje abajo y nos ocupamos del resto.",
        mcp_aria: "Demostración de asistente de IA conectado a More Good Reviews a través de MCP.",
        mcp_prompts_aria: "Ejemplos de indicaciones",
        review_flow_aria: "Carrusel de tarjetas que muestra las solicitudes de revisión por correo electrónico, la página de reseñas, las reseñas de Google y los comentarios privados.",
        review_flow_autopilot: "Funciona en piloto automático",
        review_flow_card_email_desc: "Cuando termines con un cliente, te enviaremos automáticamente un correo electrónico con una solicitud personalizada que incluye un enlace directo a tu página de reseñas.",
        review_flow_card_email_title: "Enviar la solicitud",
        review_flow_card_feedback_desc: "Las valoraciones bajas dan prioridad a los comentarios privados para que puedas corregirlos. Los Clientes también pueden optar por dejar una reseña pública.",
        review_flow_card_feedback_title: "Recibir comentarios duros",
        review_flow_card_google_desc: "Los clientes satisfechos tienen una forma clara de dejar una reseña pública en Google , de modo que los elogios aparecen donde buscan los nuevos clientes.",
        review_flow_card_google_title: "Enviar elogios a Google",
        review_flow_card_review_desc: "Llegan a tu página de reseñas, eligen una calificación y el siguiente paso depende de cómo les haya ido.",
        review_flow_card_review_title: "El Cliente elige una calificación",
        review_flow_next: "Siguiente paso",
        review_flow_prev: "Paso anterior",
        review_flow_step_email: "Solicitud una Reseña",
        review_flow_step_feedback: "o Solicitar comentarios",
        review_flow_step_google: "Ruta a cualquier sitio de Reseña",
        review_flow_step_review: "Solicitar Puntuación",
        review_flow_steps_aria: "Reseña los pasos de la solicitud",
        summary_10_desc: "Organiza a tus clientes y reseñas para poder filtrarlos y actuar con rapidez.",
        summary_10_title: "Etiquetado de Cliente y reseñas",
        summary_11_desc: "Zapier integra More Good Reviews con las herramientas que ya utilizas.",
        summary_11_title: "Conéctate a cualquier aplicación",
        summary_12_desc: "Gestiona la reputación desde Claude, ChatGPT y otros clientes de MCP .",
        summary_12_title: "MCP para asistentes de IA",
        summary_1_desc: "Envío programado de correos electrónicos y SMS con recordatorios, en modo automático.",
        summary_1_title: "Solicitudes de revisión automática",
        summary_2_desc: "Correos electrónicos y SMS que se ajusten a tu marca, tono y oferta.",
        summary_2_title: "Plantillas de marca",
        summary_3_desc: "Recopile comentarios privados o envíe a las personas a Google, Facebook y más.",
        summary_3_title: "Páginas de Reseña",
        summary_4_desc: "Códigos imprimibles y recogida en tienda a pantalla completa.",
        summary_4_title: "Códigos QR y quiosco",
        summary_5_desc: "Integra valoraciones y reseñas en cualquier parte de tu sitio web.",
        summary_5_title: "Widgets de sitios web",
        summary_6_desc: "Una página pública y personalizable para tus mejores reseñas.",
        summary_6_title: "Página de Showcase",
        summary_7_desc: "Importar reseñas y responde desde un solo lugar.",
        summary_7_title: "Sincronización de Google y Facebook",
        summary_8_desc: "Sugerencias en la página que ayudan a los clientes a dejar una reseña.",
        summary_8_title: "Ayuda para escribir reseñas sobre IA",
        summary_9_desc: "Redacta respuestas, resúmenes, tendencias y consulta a la IA sobre tus reseñas.",
        summary_9_title: "Respuestas y análisis de la IA",
        subtitle_agencies_feature_summary: "Portal white label, acceso de clientes, escala y automatización bajo tu marca.",
        subtitle_ai_feature_summary: "Respuestas, etiquetado, análisis y asistentes integrados en tu flujo de trabajo de reputación.",
        subtitle_feature_summary: "Recopilación, visualización, IA e integraciones — listo cuando tú lo estés.",
        subtitle_mcp: "Conecta Claude, ChatGPT y otros clientes MCP, y pregunta sobre reseñas, ubicaciones y outreach con lenguaje natural.",
        subtitle_review_flow: "Pide reseñas automáticamente. Los clientes pueden dejar una reseña pública en cualquier momento. El feedback privado es opcional.",
        title: "Gestión de reputación con IA para",
        title_agencies: "Convierte las reseñas en",
        title_agencies_feature_summary: "Todo lo que las agencias necesitan",
        title_agencies_phrases: {
            branded_product: "un producto de marca propio",
            recurring_retainers: "retainer mensuales recurrentes",
            revenue_stream: "una nueva fuente de ingresos"
        },
        title_ai: "Pregúntale a tu IA",
        title_ai_feature_summary: "Todo lo que la IA puede hacer por ti",
        title_ai_phrases: {
            weekly_report: "para un informe de reputación semanal",
            send_from_chat: "para enviar solicitudes de reseña",
            next_steps: "para los próximos pasos a seguir"
        },
        title_contact: "¿Cómo podemos ayudar?",
        faq_location_pricing_a: "En Business pagas por ubicación con descuentos por volumen a medida que creces (desde 59 $\/ubicación\/mes, o 49 $\/mes si pagas anualmente), y cada ubicación incluye 5000 solicitudes de reseñas al mes. Agency incluye 5 ubicaciones y 25 000 solicitudes; las ubicaciones extra cuestan 12 $\/mes y cada una añade 5000 solicitudes más.",
        faq_location_pricing_q: "¿Cómo funcionan los precios por ubicación?",
        title_faq: "Preguntas frecuentes",
        title_feature_summary: "Todo en la caja",
        title_footer: "Deja de perseguir reseñas. Empieza a conseguirlas.",
        title_footer_ai: "sobre tu reputación",
        title_ltd: "Pague una vez y úselo para siempre con nuestra oferta de por vida por tiempo limitado.",
        title_mcp: "Pregunta a la IA sobre tu reputación",
        title_review_flow: "Convierte grandes experiencias en reseñas",
        title_phrases: {
            autopilot: "pedir reseñas en piloto automático",
            google_reviews: "conseguir más reseñas de Google",
            suggested_by_chatgpt: "ser sugerido por ChatGPT"
        },
        title_pricing: "Todas las funciones. Precios sencillos.",
        title_reviews: "No te quedes solo con nuestra palabra"
    },
    plans: {
        additional_locations_tooltip: "Añade más ubicaciones a medida que creces. Business factura cada ubicación desde 59 $\/mes (incluida la primera), con una tarifa anual más baja. Las ubicaciones extra de Agency cuestan 12 $\/mes además de las 5 incluidas, y cada extra añade 5000 solicitudes mensuales.",
        agency: {
            agency_api: "API de la agencia",
            branded_portal: "Portal de clientes de marca",
            client_invites: "Invitaciones, roles y anulaciones de Cliente",
            custom_domain: "dominio de agencia aduanera",
            everything_in_business: "Todo en el plan de negocios",
            locations_included: "5 ubicaciones incluidas",
            review_requests: "5000 solicitudes de reseñas por ubicación al mes",
            sso: "Inicio de sesión único (SSO)",
            support: "Soporte al cliente especializado",
            volume_pricing: "$12\/mes por ubicación extra"
        },
        business: {
            ai: "Respuestas, análisis y preguntas de la IA",
            api_mcp: "Servidor API y MCP",
            custom_domains: "Dominios personalizados para correo electrónico y páginas de reseñas",
            google_facebook: "Perfil de Google Business y Facebook",
            locations_included: "1 ubicación incluida",
            review_requests: "Solicitudes de revisión {count} \/ ubicación \/ mes",
            support: "Soporte al cliente especializado",
            unlimited_customers: "Clientes ilimitados",
            volume_pricing: "Precios por volumen desde $59\/mes"
        },
        descriptions: {
            agency: "Para agencias que gestionan la reputación de sus clientes bajo su propia marca. Incluye cinco ubicaciones, luego 12 $ por ubicación extra, además de un portal personalizado y acceso para clientes.",
            business: "Para empresas que gestionan su propia reputación. Pague por ubicación con descuentos por volumen y obtenga inteligencia artificial, integraciones y clientes ilimitados incluidos."
        },
        selectors: {
            agency_extras_flat: "Ubicaciones extra · {price}\/{month} cada una",
            agency_included: "{count} ubicaciones incluidas",
            agency_tier: "+{from}–{to} ubicaciones · {price}\/{month} cada una",
            agency_tier_plus: "+{from}+ ubicaciones · {price}\/{month} cada una",
            business_tier: "Ubicaciones {from}–{to} · {price}\/{month} cada una",
            business_tier_plus: "Ubicaciones {from}+ · {price}\/{month} cada una"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Añade un cliente y solicita una reseña.",
            customers_to_ask: "Encuentra clientes a quienes pedirles reseñas.",
            location_leaderboard: "Comparar el rendimiento de la ubicación",
            outreach_health: "Auditar la salud de entrega de las solicitudes",
            review_digest: "Resumen semanal de reseñas",
            send_review_requests: "Enviar solicitudes de Reseña en masa"
        },
        texts: {
            add_customer_and_ask: "Agrega un nuevo cliente usando los datos de contacto que te proporciono y luego programa una solicitud de reseña para él por correo electrónico con 2 recordatorios.",
            customers_to_ask: "Lista hasta 50 clientes a los que nunca se les ha pedido una reseña, ordenados por fecha de registro (del más reciente al más antiguo). Omite a quienes se hayan dado de baja. Incluye nombre, correo electrónico y fecha de registro.",
            import_customer: "Agregue {name} como cliente. Su correo electrónico es {email}.",
            import_customer_reply: "Se agregó {name}.",
            import_review: "Añade una reseña de 5 estrellas de {name}: El equipo fue profesional y los resultados fueron excelentes.",
            import_review_reply: "Se ha añadido la reseña de 5 estrellas de {name}.",
            location_leaderboard: "Crea una clasificación de 90 días por ubicación con el número de reseñas, la calificación promedio, el porcentaje de reseñas de 5 estrellas y la tendencia con respecto a los 90 días anteriores. Ordena por calificación y marca cualquier caída superior a 0,2 estrellas.",
            outreach_health: "Para los correos electrónicos enviados en los últimos 14 días, registre el total de correos enviados, la tasa de entrega, la tasa de apertura, la tasa de clics y la tasa de errores. Señale cualquier anomalía.",
            review_digest: "Resume todas las reseñas de los últimos 7 días. Incluye la cantidad, la calificación promedio, el desglose por fuente y ubicación, los 3 temas principales y las 3 preocupaciones principales.",
            send_review_requests: "Para los clientes que se registraron en los últimos 30 días y a quienes no se les ha solicitado, programe una solicitud de reseña por correo electrónico con dos recordatorios. Muestre primero la lista y espere mi confirmación."
        }
    },
    messages: {
        activated: "Activado exitosamente.",
        archived: "Archivado exitosamente.",
        canceled: "Cancelado exitosamente.",
        cannot_copy: "No se puede copiar al portapapeles",
        cname_active: "El estado del CNAME es activo.",
        cname_not_active: "El estado de CNAME aún no está activo.",
        connected: "Conectado exitosamente.",
        cookie_banner_text: "Utilizamos cookies para mejorar tu experiencia. Puedes personalizar tus preferencias o aceptarlas todas.",
        cookie_category_analytics_desc: "Se utilizan para medir el tráfico del sitio web y el uso de los productos. Estas cookies nos ayudan a comprender cómo los visitantes utilizan nuestro sitio.",
        cookie_category_essential_desc: "Siempre activas. Estas cookies son necesarias para el funcionamiento del sitio y no se pueden desactivar.",
        cookie_category_functional_desc: "Habilita funciones avanzadas como el chat en vivo. Estas cookies no te rastrean con fines publicitarios.",
        cookie_category_marketing_desc: "Se utiliza para publicidad y medición de campañas. Esto puede incluir píxeles publicitarios y herramientas de atribución.",
        copied: "Copiado exitosamente.",
        copied_to_all_ratings: "Copiado a todas las calificaciones. Guarde para aplicar.",
        created: "Creado exitosamente.",
        deactivated: "Desactivado exitosamente.",
        deleted: "Eliminado exitosamente",
        disconnected: "Desconectado exitosamente.",
        duplicated: "Duplicado exitosamente.",
        error: "Algo salió mal. Por favor, inténtalo de nuevo.",
        google_connect_failed: "No pudimos conectarnos a Google. Puedes intentarlo de nuevo o saltarte este paso por ahora.",
        inquiry_sent: "Gracias por su consulta. Nos pondremos en contacto en breve.",
        oauth_consent_intro: "{client} está solicitando permiso para acceder a su cuenta.",
        oauth_request_missing: "La solicitud de autorización OAuth no existe o ha caducado.",
        operation_analytics_rebuild_failed: "No se pudo crear la analítica.",
        operation_analytics_rebuild_progress: "Creando tu analítica…",
        operation_analytics_rebuild_success: "La analítica está lista.",
        operation_connection_sync_failed: "La sincronización de {integration_name} falló.",
        operation_connection_sync_progress: "Sincronizando {integration_name}…",
        operation_connection_sync_success: "Sincronización {integration_name} completada.",
        operation_customer_import_failed: "La importación del Cliente falló.",
        operation_customer_import_progress: "Importación de clientes…",
        operation_customer_import_success: "Importación del Cliente completada.",
        operation_review_import_failed: "Error al importar la Reseña .",
        operation_review_import_progress: "Importar reseñas…",
        operation_review_import_success: "Reseña de la importación completada.",
        operation_review_scrape_failed: "Falló la importación de la revisión reciente.",
        operation_review_scrape_progress: "Importando reseñas recientes…",
        operation_review_scrape_success: "Importación de la revisión reciente completada.",
        processed: "Procesado exitosamente.",
        published: "Publicado exitosamente.",
        purchased: "Compra realizada con éxito.",
        queued: "Programado exitosamente.",
        refreshed: "Actualizado exitosamente.",
        removed: "Eliminado exitosamente.",
        resubscribed: "Suscripción restaurada exitosamente.",
        revoked: "Revocado con éxito.",
        saved: "guardado exitosamente",
        scheduled: "Programado exitosamente.",
        sent: "Enviado exitosamente.",
        started: "Iniciado exitosamente.",
        stopped: "Detenido exitosamente.",
        sso_failed: "No se puede autorizar con SSO.",
        sso_invalid_callback: "Llamada de retorno SSO no válida.",
        sso_not_configured: "El inicio de sesión único (SSO) no está configurado.",
        sso_openid_config_failed: "No se pudo cargar la configuración de OpenID.",
        sso_token_exchange_failed: "No se pudo completar el intercambio de tokens SSO.",
        subscribed: "Suscrito exitosamente.",
        suspended: "Suspendido exitosamente.",
        synced: "Sincronizado exitosamente.",
        unarchived: "Desarchivado exitosamente.",
        unpublished: "Despublicado exitosamente.",
        unscheduled: "Programación cancelada exitosamente.",
        unsubscribed: "La suscripción se ha cancelado correctamente.",
        unsuspended: "Suspensión reactivada exitosamente.",
        updated: "Actualizado exitosamente.",
        upgraded: "Actualizado exitosamente.",
        validated: "Validado exitosamente.",
        verified: "Verificado exitosamente."
    },
    notices: {
        agency: "¿Tiene una agencia? Puede utilizar nuestro producto con etiqueta blanca para que sus clientes solo vean su marca cuando utilicen el servicio.",
        ai_tags: "Crea una etiqueta de IA para que las reseñas que coincidan con tus instrucciones se etiqueten automáticamente.",
        connected_apps: "Las aplicaciones que conectes a través de MCP aparecerán aquí.",
        connector: "Importa tus clientes desde miles de aplicaciones con {brand}.",
        customer_messages: "Solicita una Reseña para programar mensajes.",
        customer_reviews: "Solicitar una reseña de este cliente.",
        customers: "Importa a tus clientes para comenzar a solicitar reseñas.",
        customers_import_yourself: "Importa a tus clientes para comenzar a solicitar reseñas. También puedes importarte primero para probar la experiencia antes de invitar a nadie más.",
        external_links: "Añade enlaces externos a tu portal de clientes para ayudar a vender tus servicios. Estos enlaces se mostrarán a tus clientes en la barra lateral.",
        links: "Agregue botones a su página para dejar reseñas en sitios web de terceros.",
        locations: "Crea una ubicación para poder atribuir reseñas a varias ubicaciones.",
        ltd: "Canjea de 1 a 5 códigos de acceso en esta cuenta (máximo 5). Cada código suma su límite mensual de solicitudes y 20 ubicaciones. Las solicitudes mensuales son la suma de todos los códigos canjeados. Tres o más códigos activan las funciones de la agencia. Ingresa tus códigos a continuación, separados por comas.",
        mcp_example_prompts: "Una vez conectado el servidor MCP , pegue estos datos en su asistente como punto de partida.",
        messages: "Todas las solicitudes y recordatorios se mostrarán aquí cuando se soliciten reseñas de sus clientes.",
        no_commissions: "Aún no has ganado ninguna comisión.",
        no_payouts: "Los pagos se envían manualmente una vez que su saldo aprobado alcance al menos $50.00 y su cuenta bancaria esté conectada.",
        no_projects: "Aún no se le ha asignado un proyecto. Contacte a su administrador para obtener acceso.",
        no_referrals: "Todavía no has recomendado a nadie. Comparte tu enlace de recomendación para empezar.",
        qr_codes: "Crea códigos QR con colores, ubicaciones y etiquetas personalizadas. Descárgalos como SVG o PNG.",
        referrals_share_subject: "Mi gestor de reputación con IA",
        referrals_share_text: "Mi arma secreta para obtener reseñas de negocios: More Good Reviews. Gestión de reputación con IA que realmente funciona. Regístrate con mi enlace:",
        review_pages: "Tu proyecto puede tener varias páginas de reseñas para que tus clientes dejen reseñas. Esto resulta útil para empresas con más de una ubicación.",
        reviews: "Estamos esperando las reseñas de sus clientes.",
        showcase: "Recién estamos empezando.",
        signatures: "Crea una firma de correo electrónico para copiar y pegar en tu aplicación de correo electrónico.",
        sources: "Crea una fuente para que puedas categorizar tus reseñas.",
        tag_rules: "Crea una regla para categorizar tus reseñas automáticamente con IA.",
        tags: "Crea una etiqueta para categorizar tus reseñas y clientes.",
        unauthorized: "No tienes permiso para acceder a esta página.",
        unsubscribed: "Ahora has cancelado tu suscripción a las solicitudes de Reseña.",
        webhooks: "Agregue webhooks para recibir notificaciones sobre eventos de la plataforma.",
        widgets: "Crea widgets para insertar reseñas en tu sitio web.",
        your_referral_link_text: "Comparte tu enlace para ganar una comisión recurrente del {rate}% por cada pago de los clientes que refieras. Los pagos se envían manualmente una vez que tu saldo aprobado alcance al menos $50.00."
    },
    notification_types: {
        descriptions: {
            imports: "Se envía cuando se completan las importaciones",
            new_reviews: "Se envía cuando se reciben reseñas",
            sent_replies: "Se envía cuando se responde automáticamente a las reseñas.",
            weekly_reports: "Un resumen de la actividad enviado semanalmente"
        },
        names: {
            imports: "Importaciones",
            new_reviews: "Nuevas Reseñas",
            sent_replies: "Respuestas enviadas",
            weekly_reports: "Informes semanales"
        }
    },
    roles: {
        admin: "Administración",
        manager: "Gerente",
        operator: "Operador",
        owner: "Dueño",
        super_admin: "Superadministrador",
        viewer: "Espectador"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Aceptar invitación",
        accepting_invite: "Aceptando invitación",
        access_denied: "Acceso denegado",
        account: "Cuenta",
        actions: "Acciones",
        add_custom_field: "Agregar campo personalizado",
        add_ons: "Complementos",
        address: "Dirección",
        agencies: "Agencias",
        agency: "Agencia",
        ai: "AI",
        ai_assistant: "Asistente de IA",
        ai_highlights: "Aspectos destacados de la IA",
        ai_replies: "Respuestas de IA",
        ai_review_suggestions: "Sugerencias de Reseña de IA",
        ai_tags: "Etiquetas de IA",
        ai_tools: "Herramientas de IA",
        analytics: "Analítica",
        api: "API",
        api_key: "Clave API",
        appearance: "Apariencia",
        application_connectors: "Conectores de aplicación",
        attributes: "Atributos",
        authorize: "Autorizar",
        auto_tagging: "Etiquetado automático",
        automate: "Automatizar",
        automatic_review_collection: "Recopilación automática de Reseña",
        billing: "Facturación",
        branding: "Marca",
        change_password: "Cambiar la contraseña",
        clients: "Clientes",
        cname: "CNAME",
        conditions: "Condiciones",
        confirmation_message: "Mensaje de confirmación",
        connected_apps: "Aplicaciones conectadas",
        contact_us: "Contáctenos",
        cookie_policy: "Política de cookies",
        cookie_preferences: "Preferencias de cookies",
        copy: "Copiar",
        create_your_account: "Crea tu cuenta",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Campo personalizado",
        custom_fields: "Campos personalizados",
        custom_icons: "Iconos personalizados",
        customer: "Cliente",
        customer_facing_pages: "Páginas de cara al cliente",
        customers: "Clientes",
        dashboard: "Panel de control",
        details: "Detalles",
        dmarc: "DMARC",
        domain: "Dominio",
        dpa: "Acuerdo de procesamiento de datos",
        dsar: "Solicitud de acceso del interesado a los datos",
        email_address: "Dirección de correo electrónico",
        email_messages: "Mensajes de correo electrónico",
        email_settings: "Configuración de correo electrónico",
        email_usage: "Uso del correo electrónico",
        emails: "Correos electrónicos",
        embed_code: "Código de inserción",
        example_chat: "Ejemplo de chat",
        examples: "Ejemplos",
        export: "Exportar",
        external_link: "Enlace externo",
        external_link_num: "Enlace externo #{num}",
        external_links: "Enlaces externos",
        features: "Funciones",
        feedback_form: "Formulario de comentarios",
        field: "Campo",
        fields: "Campos",
        filters: "Filtros",
        form_fields: "Campos de formulario",
        got_access_code: "¿Tienes un código de acceso?",
        hipaa: "Declaración de HIPAA",
        how_it_works: "Cómo funciona",
        incentive: "Incentivo",
        instructions: "Instrucciones",
        integration: "Integración",
        integrations: "Integraciones",
        javascript: "JavaScript",
        latest_reviews: "Últimas Reseñas",
        location_leaderboard: "Clasificación de ubicaciones",
        lifetime_deal: "Oferta de por vida",
        lifetime_deal_terms: "Términos de la oferta de por vida",
        limits: "Límites",
        link: "Enlace",
        links: "Enlaces",
        location: "Ubicación",
        location_picker: "Selector de ubicación",
        locations: "Ubicaciones",
        log_in: "Acceso",
        log_out: "Finalizar la sesión",
        make_default: "Establecer como predeterminado",
        manage_limits: "Gestionar límites",
        manage_overrides: "Administrar anulaciones",
        manage_review: "Gestionar Reseña",
        mcp_example_prompts: "Ejemplos de indicaciones",
        mcp_server: "Servidor MCP",
        message: "Mensaje",
        messages: "Mensajes",
        meta: "Meta",
        no_clients: "Sin clientes",
        no_commissions: "Sin comisiones",
        no_connected_apps: "No hay aplicaciones conectadas",
        no_custom_fields: "Sin campos personalizados",
        no_customers: "No hay clientes",
        no_links: "Sin Enlaces",
        no_locations: "Sin ubicaciones",
        no_members: "Sin miembros",
        needs_attention: "Requiere atención",
        no_messages: "No hay mensajes",
        no_payouts: "Sin pagos",
        no_projects: "Sin proyectos",
        no_qr_codes: "Sin códigos QR",
        no_referrals: "Sin referencias",
        no_review_pages: "Sin Páginas de Reseña",
        no_reviews: "Sin Reseñas",
        no_tags: "Sin Etiquetas",
        no_team_members: "Sin miembros del equipo",
        no_template: "Sin plantilla",
        no_widgets: "Sin widgets",
        notifications: "Notificaciones",
        options: "Opciones",
        overview: "Descripción general",
        payment_method: "Método de pago",
        photo: "Foto",
        plans: "Planes",
        powered_by: "Desarrollado por",
        pricing: "Precios",
        privacy_policy: "política de privacidad",
        profile: "Perfil",
        project: "Proyecto",
        project_limits: "Límites del proyecto",
        project_overrides: "Anulaciones de proyectos",
        projects: "Proyectos",
        qr_code: "Código QR",
        qr_codes: "Códigos QR",
        ratings: "Calificaciones",
        redeem_access_code: "Canjear código de acceso",
        redirecting: "Redireccionando",
        redirects: "Redirecciones",
        referrals_commissions: "Comisiones",
        referrals_payouts: "Pagos",
        referral_program: "Términos del programa de referidos",
        reminders: "Recordatorios",
        reply: "Responder",
        request: "Solicitud",
        request_options: "Opciones de solicitud",
        requests: "Solicitudes",
        required: "Requerido",
        reschedule_message: "Reprogramar mensaje",
        reset_password: "Restablecer contraseña",
        resource_limits: "Límites de recursos",
        retries: "Reintentos",
        review: "Reseña",
        review_link: "Enlace de Reseña",
        review_page: "Página de reseña",
        review_pages: "Páginas de reseña",
        review_spotlight: "Reseña destacada",
        review_suggestions: "Sugerencias de Reseña",
        review_wall: "Muro de reseñas",
        review_velocity: "Reseñas por semana",
        reviewer: "Autor de la reseña",
        reviews: "Reseñas",
        save_changes: "Guardar cambios",
        schedule: "Cronograma",
        scrape_a_website: "Extraer de un sitio web",
        search_engines: "Motores de búsqueda",
        sections: "Secciones",
        select_csv_file: "Seleccionar archivo CSV",
        select_project: "Seleccionar un proyecto",
        selecting_project: "Seleccionar proyecto",
        sending_domain: "Envío de dominio",
        sending_limits: "Límites de envío",
        sentiment: "Sentimiento",
        settings: "Ajustes",
        setup: "Configuración",
        setup_basics: "Su estrategia de Solicitud",
        setup_business: "Empecemos",
        setup_google: "Tu perfil de Google Business",
        setup_trusted: "Con la confianza de más de 5000 empresas.",
        showcase: "Showcase",
        sign_up: "Inscribirse",
        signature: "Firma de correo",
        signatures: "Firmas de correo",
        signing_in: "Iniciar sesión",
        single_sign_on: "Inicio de sesión único",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Mensajes SMS",
        sms_usage: "Uso de SMS",
        smtp_configuration: "Configuración SMTP",
        source: "Fuente",
        sources: "Fuentes",
        star_mix: "Desglose de calificaciones",
        space: "Espacio de trabajo",
        spaces: "Espacios de trabajo",
        stats: "Estadísticas",
        sub_processors: "Subprocesadores",
        success_page: "Pagina de éxito",
        summary: "Resumen",
        tag: "Etiqueta",
        tag_rule: "Regla de etiqueta",
        tags: "Etiquetas",
        team_members: "Miembros del equipo",
        template: "Plantilla",
        templates: "Plantillas",
        terms_of_service: "Condiciones de servicio",
        two_factor_authentication: "Autenticación de dos factores",
        unable_to_complete_request: "No se pudo completar la solicitud.",
        unique_review_link: "Enlace de Reseña único",
        unsent_messages: "Mensajes no enviados",
        unsubscribe: "Darse de baja",
        update_plan: "Plan de actualización",
        usage: "Uso",
        user: "Usuario",
        user_info: "Información del usuario",
        verify_email_address: "Verificar dirección de correo electrónico",
        verifying_email: "Verificando correo electrónico",
        visibility: "Visibilidad",
        webhook: "Webhook",
        webhooks: "Webhooks",
        website: "Sitio web",
        white_label_api: "API de marca blanca",
        white_label_client_portal: "Portal de clientes de marca blanca",
        white_label_image_urls: "URL de imágenes de marca blanca",
        white_label_sending_domain: "Dominio de envío de marca blanca",
        white_label_widget_tag: "Etiqueta de widget de marca blanca",
        widget: "Widget",
        widget_num: "Widget #{num}",
        widgets: "Widgets",
        your_plan: "Tu plan"
    },
    tones: {
        apologetic: "Apologético",
        casual: "Casual",
        empathetic: "Empático",
        enthusiastic: "Entusiasta",
        formal: "Formal",
        friendly: "Amigable",
        grateful: "Agradecido",
        humorous: "Humorístico",
        informative: "Informativo"
    },
    widgets: {
        labels: {
            alignment: "Alineación",
            animation: "Animación",
            autoplay: "Reproducción automática",
            autoplay_delay: "Retraso de reproducción automática",
            avatar: "Avatar",
            background_color: "Color de fondo",
            border: "Borde",
            border_color: "Color del borde",
            border_radius: "Radio del borde",
            border_width: "Ancho del borde",
            carousel: "Carrusel",
            colors: "Colores",
            company: "Compañía",
            customer: "Cliente",
            customer_position: "Posición del cliente",
            date: "Fecha",
            delay: "Demora",
            design: "Diseño",
            design_prompt_placeholder: "Ejemplo: Suave y minimalista, con estrellas doradas y esquinas redondeadas.",
            drop_shadow: "Sombra paralela",
            duration: "Duración",
            filters: "Filtros",
            font: "Fuente",
            font_emphasis: "Énfasis de fuente",
            font_family: "Familia de fuentes",
            font_size: "Tamaño de fuente",
            include_hidden: "Incluir Reseñas ocultas",
            layout: "Disposición",
            limit: "Reseñas por página",
            location_ids: "Ubicaciones",
            marquee: "Marquee",
            max_slides: "Diapositivas máximas",
            max_width: "Ancho máximo",
            name_convention: "Nombre",
            padding: "Relleno",
            pagination: "Paginación",
            quotes: "Citas",
            rating: "Puntuación",
            rating_round: "Redondeo",
            rating_round_hundredth: "Centésima más cercana (4,94)",
            rating_round_tenth: "Décima más cercana (4.9)",
            review: "Reseña",
            review_chars: "Duración de la Reseña",
            review_count: "Recuento de Reseña",
            review_id: "Reseña",
            review_ids: "Reseñas",
            review_ids_for_faces: "Reseñas de Faces",
            reviews: "Reseñas",
            schema: "Esquema",
            schema_name: "Nombre de la empresa",
            schema_type: "Tipo de negocio",
            score: "Calificación más baja",
            show_on_mobile: "Mostrar en el móvil",
            slider: "Control deslizante",
            sort: "Clasificar",
            source: "Fuente",
            source_ids: "Fuentes",
            source_position: "Posición de la fuente",
            speed: "Velocidad",
            star_color: "Color de estrella",
            star_display: "Visualización de estrellas",
            star_size: "Tamaño de la estrella",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Etiquetas",
            take: "Número máximo de Reseñas",
            text_color: "Color del texto",
            truncate: "Reseña acortada",
            visible_slides: "Diapositivas visibles",
            width: "Ancho"
        },
        types: {
            badge: "Insignia",
            carousel: "Carrusel",
            carousel_dynamic: "Carrusel dinámico",
            corner: "Esquina",
            corner_dynamic: "Esquina dinámica",
            faces: "Caras",
            headline: "Titular",
            highlights: "Destacados",
            marquee: "Marquee",
            spotlight: "Destacado",
            wall: "Muro"
        }
    }
}